<template>
    <div id="dashboard-value-players" class="justify-content-center" style="width: 100%;">
        <div class="col-xl-9 col-md-12 mt-3 mx-auto">
            <div class="title"  style="height: 43px;">
                <span class="pl-2">Value Ontology</span>
                <span class="align-middle ml-1 button-center" v-if="isDashboardView">
                    <modal-link modal-id="Value Ontology" :content-list="pageContentForDashboard" :image-size="'large'"></modal-link>
                </span>
            </div>
        </div>
        <div class="col-xl-9 col-md-12 mx-auto mt-3">
            <!-- <div class="dashboard-value-players-intro row justify-content-center">
                Value Ontology maps how value flows between your teams, customers, and suppliers by connecting expectations, perceptions, operations, and finances into a single view.
            </div> -->
            <div class="dashboard-value-players-intro">
                Value Ontology maps how value flows between your teams, customers, and suppliers by connecting expectations, perceptions, operations, and finances into a single view.
            </div>
            <div class="row justify-content-start justify-content-xl-center flex-nowrap">

                <!-- Column 0 -->
                <div class="col-auto font-weight-bold">
                    <label class="sub-heading-label mb-1">Value Profile</label>
                    <div class="">
                        <select id="ontology-value-profile" class="form-control" v-model="valueProfileClientChartId" :disabled="!valueProfileOptions.length" @change="logChangeEventForValuePlayerValueProfile">
                        <option v-if="!valueProfileOptions.length" value="">No saved Value Profiles</option>
                        <option v-for="profile in valueProfileOptions" :key="profile.clientChartId" :value="String(profile.clientChartId)">{{ profile.name }}</option>
                    </select>
                    </div>
                </div>

                <!-- Divider -->
                <div class="divider ml-2 mr-2"></div>

                <!-- Column 1 -->
                <div class="col-auto font-weight-bold">
                    <label class="sub-heading-label">Ontology Views</label>
                </div>

                <!-- Column 2 -->
                <div class="col-auto">
                    <div class="font-weight-bold">
                        <label class="d-flex align-items-center align-middle mr-1">
                            <input type="radio" class="align-middle mr-1" name="labelMode" value="actions"
                                v-model="labelMode">
                            <span class="align-middle ontology-filter-label">Value Process</span>
                        </label>
                    </div>
                    <div>
                        <label class="d-flex align-items-center align-middle mr-1">
                            <input type="radio" class="align-middle mr-1" name="labelMode" value="needs"
                                v-model="labelMode">
                            <span class="align-middle ontology-filter-label">Value Sources</span>
                        </label>
                    </div>
                </div>

                <!-- Column 3 -->
                <div class="col-auto">
                    <div class="font-weight-bold">
                        <label class="d-flex align-items-center align-middle mr-1">
                            <input type="radio" class="align-middle mr-1" name="labelMode" value="metrics"
                                v-model="labelMode">
                            <span class="align-middle ontology-filter-label">Financials & Metrics</span>
                        </label>
                    </div>
                    <div v-show="false">
                        <label class="d-flex align-items-center align-middle mr-1">
                            <input type="radio" class="align-middle mr-1" name="labelMode" value="moats"
                                v-model="labelMode">
                            <span class="align-middle ontology-filter-label">Competitive Moats</span>
                        </label>
                    </div>
                </div>
                
                <!-- Divider -->
                <div class="divider ml-2 mr-2"></div>
                
                <!-- Column 4 -->
                <div class="col-auto font-weight-bold">
                    <label class="sub-heading-label">View Spotlights</label>
                </div>

                <!-- Column 5 -->
                <div class="col-auto">
                    <div class="font-weight-bold">
                        <label class="d-flex align-items-center align-middle mr-1">
                            <input type="radio" class="align-middle mr-1" name="showSpotlights" value="stakes" v-model="showSpotlights"  :disabled="!isStakesAvailable">
                            <span class="align-middle ontology-filter-label">Premium/Table Stakes</span>
                        </label>
                    </div>
                    <div>
                        <label class="d-flex align-items-center align-middle mr-1">
                            <input type="radio" class="align-middle mr-1" name="showSpotlights" value="traffic" v-model="showSpotlights"  :disabled="!isTrafficSignalsAvailable">
                            <span class="align-middle ontology-filter-label">Traffic Lights</span>
                        </label>
                    </div>
                </div>

                <!-- Column 6 -->
                <div class="col-auto" v-show="false">
                    <div class="font-weight-bold">
                        <label class="d-flex align-items-center align-middle mr-1">
                            <input type="radio" class="align-middle mr-1" name="showSpotlights" value="directionalArrows" v-model="showSpotlights" :disabled="!isDirectionalArrowsAvailable">
                            <span class="align-middle ontology-filter-label">Directional Arrows</span>
                        </label>
                    </div>
                    
                </div>

            </div>

        </div>
        <div name="value-player-chart" class="mx-auto" v-show="valueProfileOptions.length > 0">
            <div class="chartWrapper mx-auto position-relative">
                <chart-display-skeleton
                    v-if="loadingValuePlayers"
                    class="dashboard-value-players-skeleton"
                    :width="1100"
                    :height="600"
                />
                <div ref="chartEl" v-show="!loadingValuePlayers" class="chart justify-content-center align-items-center mx-auto"></div>
            </div>
        </div>
            
    </div>
</template>

<script>
import { markRaw } from "vue";
import DashboardMixins from "../mixins/DashboardMixins.vue";
import ViewMixins from "../mixins/ViewMixins.vue";
import AdminMixins from "../mixins/AdminMixins.vue";
import AdminService from "../services/admin.service";
import ValuePlayerService from "../services/value.player.service";
import ClientChartService from "../services/client.chart.service";
import ChartDisplaySkeleton from "./skeleton/ChartDisplaySkeleton.vue";
import NeedQuestionService from "../services/need.question.service";
import AlertService from "../services/alert.service";
import PrintAndCopyService from "../services/print.and.copy.service";
import UserSettingsService from "../services/user.settings.service";
import echarts from "echarts/lib/echarts";
import "echarts/lib/chart/custom";
import "echarts/lib/chart/lines";
import "echarts/lib/chart/graph";
import "echarts/lib/component/grid";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/graphic";

export default {
    name: "DashboardValuePlayers",
    mixins: [AdminMixins, ViewMixins, DashboardMixins],
    components: {
        ChartDisplaySkeleton
    },
    data() {
        return {
            chart: null,
            showSpotlights: "",
            isRestoringUserSettings: false,
            // showDirectionalArrows: false,
            showInitiatives: false,
            valueProfileClientChartId: "",
            loadingValuePlayers: false,
            node_coords: [
                { id: "1", x: 18, y: 64 },
                { id: "2", x: 21, y: 44 },
                { id: "3", x: 33, y: 38 },
                { id: "4", x: 75, y: 38 },
                { id: "5", x: 70, y: 86 },
                { id: "6", x: 45, y: 60 },
                { id: "7", x: 26, y: 84 },
                { id: "8", x: 50, y: 86 },
                { id: "9", x: 55, y: 38 },
                { id: "10", x: 83, y: 60 }
            ],
            // Configured line geometry and its player endpoints.{ id: "7", x: 30, y: 86 },
            dottedLines: [
                { id: '1', sourcePlayerId: '6', targetPlayerId: '1', startX: 41, startY: 63, endX: 21, endY: 63 },
                { id: '2', sourcePlayerId: '6', targetPlayerId: '2', startX: 42, startY: 63, endX: 20, endY: 44 },
                { id: '3', sourcePlayerId: '6', targetPlayerId: '3', startX: 42, startY: 63, endX: 35, endY: 44 },
                { id: '4', sourcePlayerId: '4', targetPlayerId: '9', startX: 71, startY: 38, endX: 59, endY: 38 },
                { id: '5', sourcePlayerId: '5', targetPlayerId: '4', startX: 71, startY: 79, endX: 75, endY: 45 },
                { id: '6', sourcePlayerId: '7', targetPlayerId: '6', startX: 46.5, startY: 85, endX: 45, endY: 66 },
                { id: '7', sourcePlayerId: '6', targetPlayerId: '7', startX: 43, startY: 62, endX: 28, endY: 79 },
                { id: '8', sourcePlayerId: '5', targetPlayerId: '6', startX: 71, startY: 79, endX: 49, endY: 62 },
                { id: '9', sourcePlayerId: '8', targetPlayerId: '6', startX: 53.5, startY: 83.5, endX: 48, endY: 64 },
                { id: '10', sourcePlayerId: '9', targetPlayerId: '3', startX: 51, startY: 38, endX: 36, endY: 38 },
                { id: '11', sourcePlayerId: '9', targetPlayerId: '6', startX: 53, startY: 44, endX: 47, endY: 54 },
                { id: '12', sourcePlayerId: '5', targetPlayerId: '10', startX: 71, startY: 79, endX: 81, endY: 66 },
            ],
            moat_display_options: {
                "pioneer-moats": ["Brand Perception", "Upstart Power", "Channel Lock-Out"],
                "core-moats": ["Value Chain", "Design Dominance"],
                "rocket-moats": ["Routine Reliance", "Economies of Skill", "Economies of Scale", "Switching Lock-In", "Network Effect", "Time Multiplier"]
            },
            //playerNodes: [],
            connectors: [],
            //surveyId: 41822,
            //clientTimePeriodId: 23559,
            functionalNeedsList: [],
            EMOTIONAL_ORDER: ["Trust", "Adaptability", "Activity", "Creativity", "Assurance"],
            emotionalNeedsList: [],
            labelMode: "actions", // 'actions' | 'metrics' | 'needs' | 'moats'
            saved_metric_options: [],
            metrics: [],
            metricsDisplay: "",
            signals: [],
            signalsDisplay: "",
            includeValuePlayers: false,
            valuePlayerRequestId: 0,
            marketType: "",
        };
    },
    props: {
        surveyGroupId: {
            type: [String, Number],
            default: ""
        },
        surveyId: {
            type: Number,
            default: 0
        },
        entrySurveyCode: {
            type: String,
            default: ""
        },
        entrySurveyName: {
            type: String,
            default: ""
        },
        viewType: {
            type: String,
            default: "standard"
        },
        entryClientObject: {
            type: Object,
            default: function () {
                return {};
            }
        },
        pageContentForDashboard: {
            type: Array,
            default: function () {
                return [];
            },
        },
        clientTimePeriodId: {
            type: String,
            default: ""
        },
        playerNodes: {
            type: Array,
            default: function () {
                return [];
            },
        }
    },
    computed: {
        valueProfileOptions() {
            return ClientChartService.getValueProfileCards(this.entryClientObject.clientCharts, this.surveyId);
        },
        valuePlayerContext() {
            return JSON.stringify([this.surveyId, this.valueProfileClientChartId]);
        },
        showTraffic() {
            return this.showSpotlights === "traffic";
        },
        showStakes() {
            return this.showSpotlights === "stakes";
        },
        showDirectionalArrows() {
            return this.showSpotlights === "directionalArrows";
        },
        spotlightPeriodDisplay() {
            if (this.showDirectionalArrows) return this.metricsDisplay;
            if (this.showTraffic || this.showStakes) return this.signalsDisplay;
            return "";
        },
        isDashboardView: function () {
            return this.viewType == "dashboard"
        },
        showActions() {
            return this.labelMode === "actions"; // Value Process view
        },
        showMetrics() {
            return this.labelMode === "metrics"; // Financial/Metrics view
        },
        showMoats() {
            return this.labelMode === "moats"; // Competitive Moats view
        },
        showNeeds() {
            return this.labelMode === "needs"; // Value Sources view
        },
        isDirectionalArrowsAvailable() {
            // Directional arrows works only for Financial/Metrics views
            return this.showMetrics
        },
        isTrafficSignalsAvailable() {
            // Traffic Signals works for all views except Financial/Metrics views
            return this.showNeeds || this.showActions || this.showMoats
        },
        isStakesAvailable() {
            // Stakes works for all views except Financial/Metrics views
            return this.showNeeds || this.showActions || this.showMoats
        }
    },
    created() {
        this.fetchValuePlayerUserSettings();
        // this.fetchValuePlayerNodesData();
    },
    mounted() {
        this.chart = markRaw(echarts.init(this.$refs.chartEl));
        this.render();
    },
    beforeUnmount() {
        this.valuePlayerRequestId++;
        if (this.chart) this.chart.dispose();
    },
    watch: {
        playerNodes: {
            deep: true,
            handler() {
                if (!this.loadingValuePlayers) this.render();
            }
        },
        valueProfileOptions: {
            immediate: true,
            handler(profiles) {
                if (!profiles.some(profile => String(profile.clientChartId) === this.valueProfileClientChartId)) {
                    const savedProfileId = String(UserSettingsService.getUserSetting("value-player-value-profile-client-chart-id") || "");
                    this.valueProfileClientChartId = profiles.some(profile => String(profile.clientChartId) === savedProfileId)
                        ? savedProfileId
                        : profiles.length ? String(profiles[0].clientChartId) : "";
                }
            }
        },
        showSpotlights() {
            if (!this.isRestoringUserSettings) {
                this.logChangeEventForValuePlayerSpotlight();
            }
            this.render();
        },
        labelMode() {
            if (!this.isRestoringUserSettings) {
                this.logChangeEventForValuePlayerLabelMode();
                this.showSpotlights = "";
            }
            if(this.labelMode === "metrics") {
                this.showSpotlights = "directionalArrows";
            } else {
                this.showSpotlights = "";
            }
            //this.showDirectionalArrows = false,
            this.showInitiatives = false,
            this.render();
        },
        // clientTimePeriodId: {
        //     handler() {
        //         this.render();   // rebuild chart based on new filter
        //     },
        //     immediate: false
        // },
        valuePlayerContext: {
            handler() {
                this.fetchValuePlayerNodesData();
            },
            immediate: true
        }
    },
    methods: {
        async fetchValuePlayerNodesData() {
            const requestId = ++this.valuePlayerRequestId;
            const context = this.valuePlayerContext;
            const surveyId = this.surveyId;
            const clientTimePeriodId = Number(this.clientTimePeriodId);
            const selection = { clientTimePeriodId, clientChartId: this.valueProfileClientChartId };
            const chartAttributesSelection = { clientTimePeriodId, surveyGroupId: this.surveyGroupId, clientChartId: this.valueProfileClientChartId };
            const isCurrent = () => requestId === this.valuePlayerRequestId && context === this.valuePlayerContext;
            const currentCallback = callback => response => {
                if (isCurrent()) callback.call(this, response);
            };
            this.metrics = [];
            this.metricsDisplay = "";
            this.signals = [];
            this.signalsDisplay = "";
            this.functionalNeedsList = [];
            this.emotionalNeedsList = [];
            this.connectors = [];
            if (this.chart) this.chart.clear();
            this.loadingValuePlayers = Boolean(surveyId && selection.clientChartId);
            if (!this.loadingValuePlayers) return;
            try {
                await this.$nextTick();
                if (!isCurrent()) return;
                await NeedQuestionService.getNeedQuestionMetrics(surveyId, currentCallback(this.getNeedQuestionMetricsCallback), this, selection);
                if (!isCurrent()) return;
                await ValuePlayerService.getValuePlayerSignalMapping(surveyId, clientTimePeriodId, currentCallback(this.getValuePlayerSignalMappingCallback), this, selection.clientChartId);
                if (!isCurrent()) return;
                await ValuePlayerService.getValuePlayerChartAttributes(surveyId, currentCallback(this.getValuePlayerChartAttributesCallback), this, chartAttributesSelection);
                if (!isCurrent()) return;
                await ValuePlayerService.getValuePlayerMappingData(surveyId, currentCallback(this.getValuePlayerMappingDataCallback), this);
            } finally {
                // if (isCurrent()) {
                //     this.loadingValuePlayers = false;
                //     await this.$nextTick();
                //     if (isCurrent() && this.chart) this.chart.resize();
                // }
                if (isCurrent()) {
                    this.loadingValuePlayers = false;
                    await this.$nextTick();
                    if (this.chart) {
                        this.chart.resize();
                        this.render();
                    }
                }
            }
        },
        getValuePlayerChartAttributesCallback(response) {
            this.signalsDisplay = "";
            let statusCode = response.data.statusCode;
            if (statusCode == 200) {
                this.signalsDisplay = response.data.data.display || "";
                this.marketType = response.data.data.marketType;
                let functionalNeedsList = response.data.data.functional;
                functionalNeedsList = functionalNeedsList.map(conn => {
                    const match = (this.signals || []).find(
                        met => String(met.questionId) === String(conn.questionId)
                    );
                    return {
                        ...conn,
                        signalColor: match?.signalColor || "",
                        stakes: match?.liftSeriesName || "",
                    };
                });

                this.functionalNeedsList = functionalNeedsList;
                this.emotionalNeedsList = this.signals
                                        .filter(s => (s.needType || "").trim().toLowerCase() === "emotional")
                                        .sort((a, b) => {
                                            const ia = this.EMOTIONAL_ORDER.indexOf((a.needLabel || "").trim());
                                            const ib = this.EMOTIONAL_ORDER.indexOf((b.needLabel || "").trim());

                                            // items not found in the fixed list go to the end
                                            return (ia === -1 ? 999 : ia) - (ib === -1 ? 999 : ib);
                                        });
            } else {
                AdminService.displayErrorMessage({ text: response.data.message });
            }
        },
        getValuePlayerMappingDataCallback(response) {
            let statusCode = response.data.statusCode;
            if (statusCode == 200) {
                this.connectors = response.data.data.map(m => ({
                    id: String(m.lineNumber),
                    src: String(m.sourceValuePlayerNodeId),
                    dst: String(m.targetValuePlayerNodeId),
                    action: m.actionText || "",
                    questionId: m.questionId
                }));

                // Keep every metric for this question, with matching directions and colors.
                this.connectors = this.connectors.map(conn => {
                    const matches = (this.metrics || []).filter(
                        met => String(met.questionId) === String(conn.questionId)
                    );
                    return {
                        ...conn,
                        metricName: matches.map(metric => metric.metricName),
                        metricPositiveOrNegative: matches.map(metric => metric.metricPositiveOrNegative),
                        metricColor: matches.map(metric => metric.metricColor)
                    };
                });

                this.connectors = this.connectors.map(conn => {
                    const match = (this.functionalNeedsList || []).find(
                        met => String(met.questionId) === String(conn.questionId)
                    );
                    return {
                        ...conn,
                        moatName: match?.moatName || "",
                        needName: match?.needName || [],
                        signalColor: match?.signalColor || [],
                        stakes: match?.stakes || []
                    };
                });

                // re-render after data arrives
                this.$nextTick(() => {
                    if (this.chart) this.render();
                });
            } else {
                AdminService.displayErrorMessage({ text: response.data.message });
            }
        },
        getNeedQuestionMetricsCallback(response) {
            this.metric_options = [];
            this.metricId = "";
            this.metricsDisplay = "";
            let statusCode = response.data.statusCode;
            if (statusCode == 200) {
                this.metricsDisplay = response.data.data.display || "";
                this.saved_metric_options = response.data.data.savedOptions;
                this.metrics = this.saved_metric_options.map(metric => ({
                    questionId: metric.questionId,
                    needQuestionId: metric.needQuestionId,
                    metricName: metric.name || "",
                    metricPositiveOrNegative: metric.positiveOrNegative || "",
                    metricColor: metric.color || ""
                }));
            } else {
                AdminService.displayErrorMessage({ text: response.data.message });
            }
        },
        getValuePlayerSignalMappingCallback(response) {
            let statusCode = response.data.statusCode;
            if (statusCode == 200) {
                this.signals = response.data.data;
            } else {
                AdminService.displayErrorMessage({ text: response.data.message });
            }
        },
        postLoadData: function () {
            this.setDisplayView(true);
            this.displayQuestions = true;
        },
        getMergedPlayers() {
            return this.playerNodes
                .filter(p => p && String(p.label ?? "").trim() !== "") // exclude null, empty, and whitespace-only labels
                .map(p => ({
                    ...p,
                    ...(this.node_coords.find(c => String(c.id) === String(p.id)) || {})
                }));
        },
        getMergedLinks() {
            return (this.connectors || [])
                .filter(c => c && c.src && c.dst)
                .map(c => [
                    c.src,
                    c.dst,
                    c.action || "",
                    c.signalColor || [],
                    c.metricName || [],
                    c.metricPositiveOrNegative || [],
                    c.moatName || "",
                    c.needName || [],
                    c.stakes || []
                ]);
        },
        playerById(id) {
            return this.getMergedPlayers().find(n => n.id === id);
        },

        getDefaultToolBox(app,modalId,reportPageTypeName,filename) {
            return ValuePlayerService.getDefaultToolBox(app,modalId,reportPageTypeName,filename);
        },

        async executeSnap() {
            if (!this.chart) return;

            // Get cropped image instead of raw chart
            const centeredUrl = await this.getCroppedChartImage();

            // Keep existing behaviour, but with the centered image
            this.imageUrl = centeredUrl;

            AlertService.showInProgressMessage(
                PrintAndCopyService.getSnapMessage(),
                "Snap in progress...."
            );

            PrintAndCopyService.copyImage(this.imageUrl);

            setTimeout(function () {
                AlertService.closeAlert(0);
            }, 1000);
        },

        async getCroppedChartImage() {
            if (!this.chart) return null;

            const baseUrl = this.chart.getDataURL({
                pixelRatio: 2,
                backgroundColor: "#fff",
                excludeComponents: ["toolbox"]
            });

            return new Promise((resolve) => {
                const img = new Image();
                img.crossOrigin = "anonymous";
                img.src = baseUrl;

                img.onload = () => {
                    const chartW = img.width;
                    const chartH = img.height;

                    // Vertical trims
                    let trimBottom = 270;
                    const paddingTop = -50;

                    if(this.showTraffic) {
                        trimBottom = 185;
                    }

                    // Horizontal trims (adjust these)
                    const trimLeft = 115;     // pixels to remove from left
                    const trimRight = 115;    // pixels to remove from right

                    const srcW = chartW - trimLeft - trimRight;
                    const srcH = chartH - trimBottom;

                    const outW = srcW;
                    const outH = srcH + paddingTop;

                    const canvas = document.createElement("canvas");
                    canvas.width = outW;
                    canvas.height = outH;

                    const ctx = canvas.getContext("2d");

                    ctx.fillStyle = "#ffffff";
                    ctx.fillRect(0, 0, outW, outH);

                    ctx.drawImage(
                        img,
                        trimLeft,            // source X (start after left trim)
                        0,                   // source Y
                        srcW,                // source width
                        srcH,                // source height
                        0,                   // destination X
                        paddingTop,          // destination Y
                        srcW,
                        srcH
                    );

                    resolve(canvas.toDataURL("image/png"));
                };

                img.onerror = () => resolve(baseUrl);
            });
        },

        buildOption() {
            const mergedPlayers = this.getMergedPlayers();
            const visiblePlayerIds = new Set(mergedPlayers.map(player => String(player.id)));
            // Labels use configured line geometry, so keep metadata even if node IDs are missing.
            const mergedLinks = (this.connectors || [])
                .filter(c => c && c.id != null)
                .map(c => {
                    return {
                        id: String(c.id),
                        src: String(c.src),
                        dst: String(c.dst),
                        action: c.action || "",
                        status: c.signal || "",
                        metricName: c.metricName || [],
                        metricPositiveOrNegative: c.metricPositiveOrNegative || [],
                        metricColor: c.metricColor || [],
                        moatName: c.moatName || "",
                        needName: c.needName || [],
                        signalColor: c.signalColor || [],
                        stakes: c.stakes || []
                    };
                })
                .filter(Boolean);

            // Keep configured connections visible even when their saved metadata is missing.
            const dottedEdges = (this.dottedLines || [])
                .map(seg => {
                    // match connector where connector.id == dottedLines.id
                    const match = mergedLinks.find(c => c.id === String(seg.id)) || {};
                    // Visibility follows the drawn endpoints; saved IDs can use pre-split numbering.
                    const sourceId = String(seg.sourcePlayerId ?? match.src);
                    const targetId = String(seg.targetPlayerId ?? match.dst);
                    if (!visiblePlayerIds.has(sourceId) || !visiblePlayerIds.has(targetId)) return null;

                    return {
                        id: seg.id,
                        startX: seg.startX,
                        startY: seg.startY,
                        endX: seg.endX,
                        endY: seg.endY,
                        action: match.action || "",
                        status: match.signal || "",
                        metricName: match.metricName || [],
                        metricPositiveOrNegative: match.metricPositiveOrNegative || [],
                        metricColor: match.metricColor || [],
                        moatName: match.moatName || "",
                        needName: match.needName || [],
                        signalColor: match.signalColor || [],
                        stakes: match.stakes || []
                    };
                })
                .filter(Boolean);

            function getDottedMidpoint(api, seg, sideOffset = 0, verticalOffset = 0) {
                // Safety guard: ensure api and api.coord are ready and initialized
                if (!api || typeof api.coord !== 'function') {
                    return;
                }

                const p1 = api.coord([seg.startX, seg.startY]);
                const p2 = api.coord([seg.endX, seg.endY]);

                // Additional guard in case coordinate resolution returns faulty specs
                if (!p1 || !p2) return;

                const mx = (p1[0] + p2[0]) / 2;
                const my = (p1[1] + p2[1]) / 2;

                const dx = p2[0] - p1[0];
                const dy = p2[1] - p1[1];
                const L = Math.hypot(dx, dy) || 1;

                let nx = -dy / L;
                let ny = dx / L;

                // FIX: If the line is horizontal (dy ≈ 0), force normal to behave as a left/right shift
                if (Math.abs(dy) < 1) {
                    nx = dx > 0 ? 1 : -1;  // direction based on line orientation
                    ny = 0;                // no vertical movement
                }

                return [
                    mx + nx * sideOffset,
                    my + ny * sideOffset + verticalOffset
                ];
            }

            // ---------------- INVERTED TRAPEZOID (top narrow, bottom wide) ----------------
            const basePlate = {
                name: "TrapezoidBase",
                type: "custom",
                coordinateSystem: "cartesian2d",
                encode: { x: 0, y: 1 },
                silent: true,
                z: 0,
                renderItem: (params, api) => {
                    try {
                        // Top narrower, bottom wider
                        const topY = 25,
                            botY = 95;
                        const topLX = 18,
                            topRX = 82; // narrow top
                        const botLX = 5,
                            botRX = 95; // wide bottom

                        // Trapezoid corners
                        const p1 = api.coord([botLX, topY]); // BL
                        const p2 = api.coord([botRX, topY]); // BR
                        const p3 = api.coord([topRX, botY]); // TR
                        const p4 = api.coord([topLX, botY]); // TL

                        return {
                            type: "group",
                            children: [
                                {
                                    type: "polygon",
                                    shape: { points: [p1, p2, p3, p4] },
                                    style: {
                                        fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                            { offset: 0, color: "#F9F9F9" },
                                            { offset: 1, color: "#F9F9F9" }
                                        ]),
                                        stroke: "#494949",
                                        lineWidth: 1.2
                                    }
                                },
                                {
                                    type: "polygon",
                                    shape: {
                                        points: [
                                            [p1[0], p1[1]],
                                            [p2[0], p2[1]],
                                            [p2[0], p2[1] + 8],
                                            [p1[0], p1[1] + 8]
                                        ]
                                    },
                                    style: { fill: "#494949" }
                                }
                            ]
                        };
                    } catch (err) {
                        return { type: "group", children: [] };
                    }
                },
                data: [0]
            };

            // ---- ICON OVERLAY SERIES ----
            const iconSeries = {
                name: "PlayerIcons",
                type: "custom",
                coordinateSystem: "cartesian2d",
                z: 20,
                // Keep image repaints separate from the needs/traffic light canvas.
                zlevel: this.showNeeds && this.showTraffic ? 1 : 0,
                renderItem: (params, api) => {
                    const player = mergedPlayers[params.dataIndex];
                    if (!player || !player.icon) return;

                    // ADDED SAFETY GUARD
                    if (!api || typeof api.coord !== 'function') {
                        return { type: "group", children: [] };
                    }
                    const coord = api.coord([player.x, player.y]);
                    const size = 50;
                    const offsetY = -52;
                    const shiftX = -5;
                    return {
                        type: "image",
                        style: {
                            image: player.icon,
                            x: coord[0] - size / 2 + shiftX,
                            y: coord[1] + offsetY,
                            width: size,
                            height: size
                        }
                    };
                },
                data: mergedPlayers
            };

            // ---------------- PLAYERS ----------------
            const chartWidth = this.chart?.getWidth() || 1100;
            const chartHeight = this.chart?.getHeight() || 600;
            const graphPlayers = mergedPlayers.map(n => {
                let point;
                if (this.chart) {
                    try {
                        point = this.chart.convertToPixel({ xAxisIndex: 0, yAxisIndex: 0 }, [n.x, n.y]);
                    } catch (err) {
                        point = null;
                    }
                }
                if (!Array.isArray(point) || !Number.isFinite(point[0]) || !Number.isFinite(point[1])) {
                    point = [20 + (n.x / 100) * (chartWidth - 40), chartHeight - (n.y / 100) * chartHeight];
                }
                return {
                id: n.id,
                name: n.label,
                value: [n.x, n.y],
                x: point[0],
                y: point[1],
                symbol: "circle",
                symbolSize: 80,
                itemStyle: { color: "#BFBFBF", borderColor: "#BFBFBF" },
                label: {
                    show: true,
                    position: "inside",
                    offset: [5, 15],
                    rotate: 15,
                    textVerticalAlign: "bottom",
                    textAlign: "center",
                    fontSize: 12,
                    fontFamily: "Franklin Gothic Demi Cond, sans-serif",
                    lineHeight: 12,
                    color: "#595959",
                    overflow: "break",
                    width: 70,
                    formatter: () => {
                        const words = String(n.label || "").split(" ");
                        const lines = [];
                        let currentLine = "";
                        for (const word of words) {
                            if ((currentLine + word).length <= 12) {
                                currentLine += (currentLine ? " " : "") + word;
                            } else {
                                lines.push(currentLine);
                                currentLine = word;
                            }
                        }
                        if (currentLine) lines.push(currentLine);
                        return lines.join("\n");
                    }
                }
                };
            });
            const graphX = graphPlayers.map(player => player.x);
            const graphY = graphPlayers.map(player => player.y);
            const graphBounds = graphPlayers.length
                ? {
                    left: Math.min(...graphX) - 1,
                    right: chartWidth - Math.max(...graphX) - 1,
                    top: Math.min(...graphY) - 1,
                    bottom: chartHeight - Math.max(...graphY) - 1
                }
                : { left: 20, right: 20, top: 0, bottom: 0 };

            // ---- DOTTED LINES WITH OPEN ARROW, USING RAW COORDS ----
            const dottedLinesSeries = {
                name: 'DottedLines',
                type: 'custom',
                coordinateSystem: 'cartesian2d',
                silent: true,
                z: 5,
                //zlevel: 4,
                animation: false,            // <--- add this
                progressive: 0,              // <--- prevent progressive rendering
                progressiveThreshold: 0,     // <--- (safety)

                renderItem: (params, api) => {
                    const seg = dottedEdges[params.dataIndex];
                    if (!seg) return { type: 'group', children: [] };
                    
                    // ADDED SAFETY GUARD
                    if (!api || typeof api.coord !== 'function') {
                        return { type: "group", children: [] };
                    }
                    
                    // Use the raw coords exactly as given
                    const p1 = api.coord([seg.startX, seg.startY]); // start
                    const p2 = api.coord([seg.endX, seg.endY]);   // end (arrow tip)

                    const dx = p2[0] - p1[0];
                    const dy = p2[1] - p1[1];
                    const len = Math.hypot(dx, dy) || 1;

                    const ux = dx / len;
                    const uy = dy / len;

                    const nx = -uy;
                    const ny = ux;

                    const arrowLength = 0; // 10 px
                    const arrowWidth = 0;  // 6 px

                    // Base of arrow a bit back from tip along the line
                    const baseX = p2[0] - ux * arrowLength;
                    const baseY = p2[1] - uy * arrowLength;

                    const leftWing = [baseX - nx * arrowWidth, baseY - ny * arrowWidth];
                    const rightWing = [baseX + nx * arrowWidth, baseY + ny * arrowWidth];

                    return {
                        type: 'group',
                        children: [
                            // dotted line from start → just before tip (so arrowhead is visible)
                            {
                                type: 'path',
                                shape: {
                                    pathData: `M ${p1[0]} ${p1[1]} L ${baseX} ${baseY}`
                                },
                                style: {
                                    stroke: '#BFBFBF',
                                    lineWidth: 2,
                                    lineDash: [1, 5],
                                    lineCap: 'round',
                                    lineJoin: 'round',
                                    fill: 'none'
                                }
                            },
                            // open arrowhead at exact endX,endY
                            {
                                type: 'polyline',
                                shape: {
                                    points: [
                                        leftWing,
                                        [p2[0], p2[1]], // tip = endX,endY
                                        rightWing
                                    ]
                                },
                                style: {
                                    stroke: '#BFBFBF',
                                    lineWidth: 1.8,
                                    fill: 'none',
                                    lineCap: 'round'
                                }
                            }
                        ]
                    };
                },
                data: dottedEdges
            };

            const showNeeds = this.showNeeds;
            const showMetrics = this.showMetrics;
            const liftColors = {
                "Untapped": "#2F5EB3",
                "In-Demand": "#D98E2C",
                "Table Stake": "#A6A6A6"
            };
            const getStakeFill = stakes => {
                const values = (Array.isArray(stakes) ? stakes : (stakes ? [stakes] : []))
                    .map(stake => String(stake || "").toLowerCase().trim());
                const matchingColor = Object.entries(liftColors).find(([stake]) =>
                    values.some(value => value.includes(stake.toLowerCase()))
                );
                return matchingColor ? matchingColor[1] : "#F9F9F9";
            };

            // ---- SINGLE TRAFFIC LIGHT (generic, one per dotted line) ----
            const actionTrafficSingleSeries = {
                id: "ActionTrafficSingle",
                name: "ActionTrafficSingle",
                type: "custom",
                coordinateSystem: "cartesian2d",
                silent: true,
                z: 101,
                //zlevel: 10,
                animation: false,
                renderItem: (params, api) => {
                    const e = dottedEdges[params.dataIndex];
                    if (!e) return { type: "group", children: [] };

                    // shared offsets
                    let sideOffset = 0;
                    let verticalOffset = -5;
                    if (String(e.id) === "5") {
                        sideOffset = 18;
                    } else if (String(e.id) === "7") {
                        verticalOffset = 10; // move down a bit
                    } else if (String(e.id) === "8") {
                        sideOffset = -18;
                        verticalOffset = 17;
                    } else if (String(e.id) === "11") {
                        sideOffset = -18;
                    }

                    const baseCenter = getDottedMidpoint(api, e, sideOffset, verticalOffset);
                    if (String(e.id) === "7") {
                        baseCenter[0] += 50;   // right
                        baseCenter[1] -= 40;   // up
                    } else if (String(e.id) === "8") {
                        baseCenter[0] += 28;   // move right
                        baseCenter[1] -= 41;   // move up
                    }

                    // Keep original indices while matching signals to metrics and needs.
                    const rawSignals = Array.isArray(e.signalColor)
                        ? e.signalColor
                        : (e.signalColor ? [e.signalColor] : []);
                    const rawMetrics = Array.isArray(e.metricName)
                        ? e.metricName
                        : (e.metricName ? [e.metricName] : []);
                    const rawNeeds = Array.isArray(e.needName)
                        ? e.needName
                        : (e.needName ? [e.needName] : []);
                    let signals = rawSignals
                        .map((signal, index) => ({
                            signal: String(signal || "").toLowerCase().trim(),
                            metricName: String(rawMetrics[index] || "").trim(),
                            needName: String(rawNeeds[index] || "").trim()
                        }))
                        .filter(entry => entry.signal
                            && (!this.showMetrics || entry.metricName)
                            && (!this.showNeeds || entry.needName))
                        .map(entry => entry.signal);

                    if (!signals.length) return { type: "group", children: [] };

                    const sig = signals[0]; // ALWAYS first one

                    const housingW = 20;
                    const housingH = 46;
                    const gray = "#bdc3c7";
                    const gapAboveLine = 12;

                    const lightX = baseCenter[0];
                    const lightYCenter = baseCenter[1] - (housingH / 2 + gapAboveLine);
                    const lightYTop = lightYCenter - housingH / 2;

                    const red = sig === "red" ? "#e74c3c" : gray;
                    const yellow = sig === "yellow" ? "#f1c40f" : gray;
                    const green = sig === "green" ? "#2ecc71" : gray;

                    return {
                        type: "group",
                        children: [
                            {
                                type: "rect",
                                shape: {
                                    x: lightX - housingW / 2,
                                    y: lightYTop,
                                    width: housingW,
                                    height: housingH,
                                    r: 4
                                },
                                style: { fill: "#2c3e50" }
                            },
                            ...[0, 1, 2].map(i => ({
                                type: "circle",
                                shape: { cx: lightX, cy: lightYTop + 8 + i * 14, r: 5 },
                                style: { fill: [red, yellow, green][i] }
                            }))
                        ]
                    };
                },
                data: dottedEdges
            };

            // ---- SINGLE STAKE (generic, one per dotted line) ----
            const actionStakesSingleSeries = {
                id: "ActionStakesSingle",
                name: "ActionStakesSingle",
                type: "custom",
                coordinateSystem: "cartesian2d",
                silent: true,
                z: 101,
                //zlevel: 10,
                animation: false,
                renderItem: (params, api) => {
                    const e = dottedEdges[params.dataIndex];
                    if (!e) return { type: "group", children: [] };

                    // shared offsets
                    let sideOffset = 0;
                    let verticalOffset = -5;
                    if (String(e.id) === "5") {
                        sideOffset = 18;
                    } else if (String(e.id) === "7") {
                        verticalOffset = 10; // move down a bit
                    } else if (String(e.id) === "8") {
                        sideOffset = -18;
                        verticalOffset = 17;
                    } else if (String(e.id) === "11") {
                        sideOffset = -18;
                    }

                    const baseCenter = getDottedMidpoint(api, e, sideOffset, verticalOffset);
                    if (String(e.id) === "7") {
                        baseCenter[0] += 50;   // right
                        baseCenter[1] -= 40;   // up
                    } else if (String(e.id) === "8") {
                        baseCenter[0] += 28;   // move right
                        baseCenter[1] -= 41;   // move up
                    }

                    // normalise stakes
                    let stakes = Array.isArray(e.stakes)
                        ? e.stakes
                        : (e.stakes ? [e.stakes] : []);
                    stakes = stakes
                        .map(s => String(s || "").toLowerCase().trim())
                        .filter(Boolean);

                    if (!stakes.length) return { type: "group", children: [] };

                    const sig = stakes[0]; // ALWAYS first one

                    const housingW = 56;
                    const housingH = 20;
                    const gray = "#bdc3c7";
                    const gapAboveLine = 12;

                    const lightX = baseCenter[0];
                    const lightYCenter = baseCenter[1] - (housingH / 2 + gapAboveLine);
                    const lightYTop = lightYCenter - housingH / 2;

                    const paddingX = 5;

                    return {
                        type: "group",
                        children: [
                            {
                                type: "rect",
                                shape: {
                                    x: lightX - housingW / 2,
                                    y: lightYTop,
                                    width: housingW,
                                    height: housingH,
                                    r: 4
                                },
                                style: { fill: getStakeFill(stakes[0]) }
                            },
                            {
                                type: "text",
                                style: {
                                    x: baseCenter[0],
                                    y: baseCenter[1] - (housingH / 2 + gapAboveLine),
                                    // text: stakes.join("\n").toUpperCase(),
                                    text: stakes[0].toUpperCase(),
                                    textAlign: "center",
                                    textVerticalAlign: "middle",
                                    fontSize: 10,
                                    lineHeight: housingH,
                                    width: housingW - paddingX * 2,
                                    // fill: "#333",
                                    fontFamily: "Franklin Gothic Medium Cond, sans-serif",
                                }
                            }
                        ]
                    };
                },
                data: dottedEdges
            };

            // ---- TRAFFIC LIGHTS (per-need when showNeeds, else single above line) ----
            const actionTrafficSeries = {
                name: "ActionTrafficLights",
                type: "custom",
                coordinateSystem: "cartesian2d",
                silent: true,
                z: 101,
                //zlevel: 10,
                animation: false,
                renderItem: (params, api) => {
                    const e = dottedEdges[params.dataIndex];
                    if (!e) return { type: "group", children: [] };
                    // --- shared offsets for this dotted line (same as needs) ---
                    let sideOffset = 0;
                    let verticalOffset = -5;
                    if (String(e.id) === "6") {
                        sideOffset = 18;
                    } else if (String(e.id) === "9") {
                        sideOffset = -18;
                        verticalOffset = 17;
                    } else if (String(e.id) === "12") {
                        sideOffset = -18;
                    } else if (String(e.id) === "2") {
                        // sideOffset = 40;
                        // verticalOffset = 3;
                    } else if (String(e.id) === "3") {
                        // sideOffset = -10;
                        verticalOffset = 15; // move down a bit
                    }

                    const baseCenter = getDottedMidpoint(api, e, sideOffset, verticalOffset, params);
                    if (!baseCenter) return { type: "group", children: [] };

                    if (String(e.id) === "2") {
                        baseCenter[0] -= 50;   // left
                        baseCenter[1] += 10;   // down
                    } else if (String(e.id) === "7") {
                        baseCenter[0] -= 30;   // left
                        baseCenter[1] -= 30;   // up
                    } else if (String(e.id) === "8") {
                        baseCenter[0] += 40;   // right
                        baseCenter[1] -= 30;   // up
                    } else if (String(e.id) === "9") {
                        baseCenter[0] += 27;   // move right
                        baseCenter[1] -= 40;   // move up
                    }

                    // Keep original indices while matching signals to metrics and needs.
                    const rawSignals = Array.isArray(e.signalColor)
                        ? e.signalColor
                        : (e.signalColor ? [e.signalColor] : []);
                    const rawNeeds = Array.isArray(e.needName)
                        ? e.needName
                        : (e.needName ? [e.needName] : []);
                    const rawMetrics = Array.isArray(e.metricName)
                        ? e.metricName
                        : (e.metricName ? [e.metricName] : []);
                    const signalEntries = rawSignals
                        .map((signal, index) => ({
                            signal: String(signal || "").toLowerCase().trim(),
                            needName: String(rawNeeds[index] || "").trim(),
                            metricName: String(rawMetrics[index] || "").trim()
                        }))
                        .filter(entry => entry.signal
                            && (!this.showMetrics || entry.metricName)
                            && (!this.showNeeds || entry.needName));
                    const signals = signalEntries.map(entry => entry.signal);
                    const needs = signalEntries.map(entry => entry.needName).filter(Boolean);

                    if (!signals.length) return { type: "group", children: [] };

                    const housingW = 20;
                    const housingH = 46;
                    const gray = "#bdc3c7";

                    const gapAboveLine = 12;
                    const gapBetweenBoxAndLights = 10;
                    const interLampGapHoriz = 8;

                    const fontSize = 11;
                    const maxWidth = 70;
                    const paddingX = 5;
                    const lineHeight = fontSize + 2;

                    const ctx =
                        this._measureCtx ||
                        document.createElement("canvas").getContext("2d");
                    ctx.font = `${fontSize}px sans-serif`;

                    const children = [];

                    // ───────────────── CASE A: showNeeds == false ─────────────────
                    // Always draw ONE traffic light above the line, using the first signal
                    if (!showNeeds & !showMetrics) {
                        const sig = signals[0];

                        const lightX = baseCenter[0];
                        const lightYCenter = baseCenter[1] - (housingH / 2 + gapAboveLine);
                        const lightYTop = lightYCenter - housingH / 2;

                        const red = sig === "red" ? "#e74c3c" : gray;
                        const yellow = sig === "yellow" ? "#f1c40f" : gray;
                        const green = sig === "green" ? "#2ecc71" : gray;

                        children.push(
                            {
                                type: "rect",
                                shape: {
                                    x: lightX - housingW / 2,
                                    y: lightYTop,
                                    width: housingW,
                                    height: housingH,
                                    r: 4
                                },
                                style: { fill: "#2c3e50" }
                            },
                            ...[0, 1, 2].map(i => ({
                                type: "circle",
                                shape: { cx: lightX, cy: lightYTop + 8 + i * 14, r: 5 },
                                style: { fill: [red, yellow, green][i] }
                            }))
                        );

                        return { type: "group", children };
                    }

                    // ───────────────── CASE B: showNeeds == true ─────────────────
                    // If we DON’T have multiple needs+signals → fall back to single light above line
                    if (!(needs.length > 1 && signals.length > 1)) {
                        const sig = signals[0];

                        const lightX = baseCenter[0];
                        const lightYCenter = baseCenter[1] - (housingH / 2 + gapAboveLine);
                        const lightYTop = lightYCenter - housingH / 2;

                        const red = sig === "red" ? "#e74c3c" : gray;
                        const yellow = sig === "yellow" ? "#f1c40f" : gray;
                        const green = sig === "green" ? "#2ecc71" : gray;

                        children.push(
                            {
                                type: "rect",
                                shape: {
                                    x: lightX - housingW / 2,
                                    y: lightYTop,
                                    width: housingW,
                                    height: housingH,
                                    r: 4
                                },
                                style: { fill: "#2c3e50" }
                            },
                            ...[0, 1, 2].map(i => ({
                                type: "circle",
                                shape: { cx: lightX, cy: lightYTop + 8 + i * 14, r: 5 },
                                style: { fill: [red, yellow, green][i] }
                            }))
                        );

                        return { type: "group", children };
                    }

                    // ───────────────── CASE C: showNeeds == true AND multiple needs/signals ─────────────────
                    // For each NEED there is a TRAFFIC SIGNAL, aligned vertically with that need,
                    // and placed to the LEFT of the needs box.

                    // 1. Rebuild allLines & track line-span for each need
                    const needBlocks = []; // { startIdx, endIdx }
                    const allLines = [];
                    let currentLineIndex = 0;

                    needs.forEach((needText, idx) => {
                        const wrapped = wrapTextByWidth(needText, maxWidth, ctx);
                        if (!wrapped.length) return;

                        const start = currentLineIndex;
                        wrapped.forEach(l => {
                            allLines.push(l);
                            currentLineIndex++;
                        });

                        const end = currentLineIndex - 1;
                        needBlocks.push({ startIdx: start, endIdx: end });

                        if (idx < needs.length - 1) {
                            // spacer line between needs – must match needsTextSeries
                            allLines.push("");
                            currentLineIndex++;
                        }
                    });

                    if (!allLines.length || !needBlocks.length) {
                        return { type: "group", children: [] };
                    }

                    const totalLines = allLines.length;
                    const totalTextHeight = totalLines * lineHeight;

                    // same center as needs box
                    const center = baseCenter;
                    const rectHeight = totalTextHeight + paddingX * 2;
                    const rectWidth = maxWidth + paddingX * 2;

                    const topTextY = center[1] - totalTextHeight / 2;

                    // X for lamps: LEFT of needs box
                    const lampX =
                        center[0] - rectWidth / 2 - gapBetweenBoxAndLights - housingW / 2;

                    const pairCount = Math.min(needs.length, signals.length);
                    const lampGlobalOffset = 0;        // or small tweak
                    const extraSpacingBetweenLamps = 15; // try 4–10

                    for (let i = 0; i < pairCount; i++) {
                        const block = needBlocks[i];
                        const sig = signals[i];

                        const midLineIndex = (block.startIdx + block.endIdx) / 2;
                        const textCenterY = topTextY + (midLineIndex + 0.5) * lineHeight;

                        //const lightYCenter = textCenterY;
                        const lightYCenter =
                            textCenterY +
                            lampGlobalOffset +
                            (i - (pairCount - 1) / 2) * extraSpacingBetweenLamps;
                        const lightYTop = lightYCenter - housingH / 2;

                        const red = sig === "red" ? "#e74c3c" : gray;
                        const yellow = sig === "yellow" ? "#f1c40f" : gray;
                        const green = sig === "green" ? "#2ecc71" : gray;

                        children.push(
                            {
                                type: "rect",
                                shape: {
                                    x: lampX - housingW / 2,
                                    y: lightYTop,
                                    width: housingW,
                                    height: housingH,
                                    r: 4
                                },
                                style: { fill: "#2c3e50" }
                            },
                            ...[0, 1, 2].map(j => ({
                                type: "circle",
                                shape: { cx: lampX, cy: lightYTop + 8 + j * 14, r: 5 },
                                style: { fill: [red, yellow, green][j] }
                            }))
                        );
                    }

                    return { type: "group", children };
                },
                data: dottedEdges
            };

            // ---- STAKES (per-need when showNeeds, else single above line) ----
            const actionStakesSeries = {
                name: "ActionStakes",
                type: "custom",
                coordinateSystem: "cartesian2d",
                silent: true,
                z: 101,
                //zlevel: 10,
                animation: false,
                renderItem: (params, api) => {
                    const e = dottedEdges[params.dataIndex];
                    if (!e) return { type: "group", children: [] };
                    // --- shared offsets for this dotted line (same as needs) ---
                    let sideOffset = 0;
                    let verticalOffset = -5;
                    if (String(e.id) === "6") {
                        sideOffset = 18;
                    } else if (String(e.id) === "9") {
                        sideOffset = -18;
                        verticalOffset = 17;
                    } else if (String(e.id) === "12") {
                        sideOffset = -18;
                    } else if (String(e.id) === "2") {
                        // sideOffset = 40;
                        // verticalOffset = 15;
                    } else if (String(e.id) === "3") {
                        // sideOffset = -10;
                        verticalOffset = 15; // move down a bit
                    }

                    const baseCenter = getDottedMidpoint(api, e, sideOffset, verticalOffset, params);
                    if (!baseCenter) return { type: "group", children: [] };

                    if (String(e.id) === "2") {
                        baseCenter[0] -= 30;   // right
                        baseCenter[1] += 10;   // up
                    } else if (String(e.id) === "7") {
                        baseCenter[0] -= 30;   // left
                        baseCenter[1] -= 30;   // up
                    } else if (String(e.id) === "8") {
                        baseCenter[0] += 40;   // right
                        baseCenter[1] -= 30;   // up
                    } else if (String(e.id) === "9") {
                        baseCenter[0] += 27;   // move right
                        baseCenter[1] -= 40;   // move up
                    }

                    // Normalise values without removing blanks so their indices stay aligned.
                    const rawStakes = Array.isArray(e.stakes)
                        ? e.stakes
                        : (e.stakes ? [e.stakes] : []);
                    const rawNeeds = Array.isArray(e.needName)
                        ? e.needName
                        : (e.needName ? [e.needName] : []);
                    const rawMetrics = Array.isArray(e.metricName)
                        ? e.metricName
                        : (e.metricName ? [e.metricName] : []);

                    const stakeEntries = rawStakes
                        .map((stake, index) => ({
                            stake: String(stake || "").toLowerCase().trim(),
                            needName: String(rawNeeds[index] || "").trim(),
                            metricName: String(rawMetrics[index] || "").trim()
                        }))
                        .filter(entry => entry.stake
                            && (!this.showMetrics || entry.metricName)
                            && (!this.showNeeds || entry.needName));
                    const stakes = stakeEntries.map(entry => entry.stake);
                    const needs = stakeEntries.map(entry => entry.needName).filter(Boolean);

                    if (!stakes.length) return { type: "group", children: [] };

                    const housingW = 56;
                    const housingH = 20;
                    const gray = "#bdc3c7";

                    const gapAboveLine = 12;
                    const gapBetweenBoxAndLights = 10;
                    const interLampGapHoriz = 8;

                    const fontSize = 11;
                    const maxWidth = 70;
                    const paddingX = 5;
                    const lineHeight = fontSize + 2;

                    const ctx =
                        this._measureCtx ||
                        document.createElement("canvas").getContext("2d");
                    ctx.font = `${fontSize}px sans-serif`;

                    const children = [];

                    // ───────────────── CASE A: showNeeds == false ─────────────────
                    // Always draw ONE stake above the line, using the first stake
                    if (!showNeeds && !showMetrics) {
                        const sig = stakes[0];

                        const lightX = baseCenter[0];
                        const lightYCenter = baseCenter[1] - (housingH / 2 + gapAboveLine);
                        const lightYTop = lightYCenter - housingH / 2;

                        children.push(
                            {
                                type: "rect",
                                shape: {
                                    x: lightX - housingW / 2,
                                    y: lightYTop,
                                    width: housingW,
                                    height: housingH,
                                    r: 4
                                },
                                style: { fill: getStakeFill(stakes[0]) }
                            },
                            {
                                type: "text",
                                style: {
                                    x: baseCenter[0],
                                    y: baseCenter[1] - (housingH / 2 + gapAboveLine),
                                    // text: stakes.join("\n").toUpperCase(),
                                    text: stakes[0].toUpperCase(),
                                    textAlign: "center",
                                    textVerticalAlign: "middle",
                                    fontSize: 10,
                                    lineHeight: housingH,
                                    width: housingW - paddingX * 2,
                                    // fill: "#333",
                                    fontFamily: "Franklin Gothic Medium Cond, sans-serif",
                                }
                            }
                        );

                        return { type: "group", children };
                    }

                    // ───────────────── CASE B: showNeeds == true ─────────────────
                    // If we DON’T have multiple metrics(or needs)+stakes → fall back to single stake above line
                    if (!(needs.length > 1 && stakes.length > 1)) {
                        const sig = stakes[0];

                        const lightX = baseCenter[0];
                        const lightYCenter = baseCenter[1] - (housingH / 2 + gapAboveLine);
                        const lightYTop = lightYCenter - housingH / 2;

                        children.push(
                            {
                                type: "rect",
                                shape: {
                                    x: lightX - housingW / 2,
                                    y: lightYTop,
                                    width: housingW,
                                    height: housingH,
                                    r: 4
                                },
                                style: { fill: getStakeFill(stakes[0]) }
                            },
                            {
                                type: "text",
                                style: {
                                    x: baseCenter[0],
                                    y: baseCenter[1] - (housingH / 2 + gapAboveLine),
                                    // text: stakes.join("\n").toUpperCase(),
                                    text: stakes[0].toUpperCase(),
                                    textAlign: "center",
                                    textVerticalAlign: "middle",
                                    fontSize: 10,
                                    lineHeight: housingH,
                                    width: housingW - paddingX * 2,
                                    fill: "#ffffff",
                                    fontFamily: "Franklin Gothic Medium Cond, sans-serif",
                                }
                            }
                        );

                        return { type: "group", children };
                    }

                    // ───────────────── CASE C: showNeeds == true AND multiple stakes per dotted line ─────────────────
                    // For each NEED there is a TRAFFIC SIGNAL, aligned vertically with that need,
                    // and placed to the LEFT of the needs box.

                    // 1. Rebuild allLines & track line-span for each need
                    const needBlocks = []; // { startIdx, endIdx }
                    const allLines = [];
                    let currentLineIndex = 0;

                    needs.forEach((needText, idx) => {
                        const wrapped = wrapTextByWidth(needText, maxWidth, ctx);
                        if (!wrapped.length) return;

                        const start = currentLineIndex;
                        wrapped.forEach(l => {
                            allLines.push(l);
                            currentLineIndex++;
                        });

                        const end = currentLineIndex - 1;
                        needBlocks.push({ startIdx: start, endIdx: end });

                        if (idx < needs.length - 1) {
                            // spacer line between needs – must match needsTextSeries
                            allLines.push("");
                            currentLineIndex++;
                        }
                    });

                    if (!allLines.length || !needBlocks.length) {
                        return { type: "group", children: [] };
                    }

                    const totalLines = allLines.length;
                    const totalTextHeight = totalLines * lineHeight;

                    // same center as needs box
                    const center = baseCenter;
                    const rectHeight = totalTextHeight + paddingX * 2;
                    const rectWidth = maxWidth + paddingX * 2;

                    const topTextY = center[1] - totalTextHeight / 2;

                    // X for lamps: LEFT of needs box
                    const lampX =
                        center[0] - rectWidth / 2 - gapBetweenBoxAndLights - housingW / 2;

                    const pairCount = Math.min(needs.length, stakes.length);
                    const lampGlobalOffset = 0;        // or small tweak
                    const extraSpacingBetweenLamps = 15; // try 4–10

                    for (let i = 0; i < pairCount; i++) {
                        const block = needBlocks[i];
                        const sig = stakes[i];

                        const midLineIndex = (block.startIdx + block.endIdx) / 2;
                        const textCenterY = topTextY + (midLineIndex + 0.5) * lineHeight;

                        //const lightYCenter = textCenterY;
                        const lightYCenter =
                            textCenterY +
                            lampGlobalOffset +
                            (i - (pairCount - 1) / 2) * extraSpacingBetweenLamps;
                        const lightYTop = lightYCenter - housingH / 2;

                        children.push(
                            {
                                type: "rect",
                                shape: {
                                    x: lampX - housingW / 2,
                                    y: lightYTop,
                                    width: housingW,
                                    height: housingH,
                                    r: 4
                                },
                                style: { fill: getStakeFill(sig) }
                            },
                            {
                                type: "text",
                                style: {
                                    x: lampX,
                                    y: lightYCenter,
                                    // text: stakes.join("\n").toUpperCase(),
                                    text: sig.toUpperCase(),
                                    textAlign: "center",
                                    textVerticalAlign: "middle",
                                    fontSize: 10,
                                    lineHeight: housingH,
                                    width: housingW - paddingX * 2,
                                    fill: "#ffffff",
                                    fontFamily: "Franklin Gothic Medium Cond, sans-serif",
                                }
                            }
                        );
                    }

                    return { type: "group", children };
                },
                data: dottedEdges
            };

            // Shared positions for metric text, arrows, and no-data placeholders.
            function getMetricLayout(api, e, params, ctx) {
                    // offsets per edge id (same as before)
                    let sideOffset = 0;
                    let verticalOffset = 0;
                    if (String(e.id) === "3") {
                        verticalOffset = 10; // move down a bit
                    } else if (String(e.id) === "5") {
                        sideOffset = 18;
                    } else if (String(e.id) === "6") {
                        sideOffset = 18;
                    } else if (String(e.id) === "8") {
                        sideOffset = 0;
                        verticalOffset = 22;
                    }

                    const center = getDottedMidpoint(api, e, sideOffset, verticalOffset, params);
                    if (!center) return;
                    if (String(e.id) === "2") {
                        center[0] -= 30;   // left
                        center[1] += 0;   // down
                    } else if (String(e.id) === "7") {
                        center[0] -= 15;   // left
                        center[1] -= 30;   // up
                    } else if (String(e.id) === "8") {
                        center[0] += 27;   // move right
                        center[1] -= 40;   // move up
                    }  else if (String(e.id) === "9") {
                        center[0] += 27;   // move right
                        center[1] -= 20;   // move up
                    } else if (String(e.id) === "11") {
                        center[0] += 30;   // move right
                        center[1] -= 10;   // move up
                    } else if (String(e.id) === "12") {
                        center[0] += 27;   // move right
                        center[1] -= 0;   // move up
                    }

                    const fontSize = 12;
                    const fontFamily = "Franklin Gothic Medium Cond, sans-serif";
                    const lineHeight = 13;
                    const gap = 6;
                    const maxRectWidth = 90;
                    const maxWidth = maxRectWidth - 10;
                    ctx.font = `${fontSize}px ${fontFamily}`;
                    const names = Array.isArray(e.metricName) ? e.metricName : [e.metricName];
                    const directions = Array.isArray(e.metricPositiveOrNegative) ? e.metricPositiveOrNegative : [e.metricPositiveOrNegative];
                    const colors = Array.isArray(e.metricColor) ? e.metricColor : [e.metricColor];
                    const entries = names.map((name, index) => ({
                        lines: wrapTextByWidth(String(name || "").trim(), maxWidth, ctx).flatMap(line => {
                            const lines = [];
                            let current = "";
                            for (const character of line) {
                                if (current && ctx.measureText(current + character).width > maxWidth) {
                                    lines.push(current);
                                    current = "";
                                }
                                current += character;
                            }
                            if (current) lines.push(current);
                            return lines;
                        }),
                        direction: String(directions[index] || "").trim().toLowerCase(),
                        color: colors[index]
                    })).filter(entry => entry.lines.length);
                    if (!entries.length) return;
                    const textWidth = entries.reduce((widest, entry) =>
                        entry.lines.reduce((width, line) => Math.max(width, ctx.measureText(line).width), widest), 0);
                    const rectWidth = Math.min(maxRectWidth, textWidth + 10);
                    const totalHeight = entries.reduce((height, entry) => height + entry.lines.length * lineHeight, 0)
                        + (entries.length - 1) * gap;
                    let top = center[1] - totalHeight / 2;
                    entries.forEach(entry => {
                        entry.height = entry.lines.length * lineHeight;
                        entry.y = top + entry.height / 2;
                        top += entry.height + gap;
                    });
                    return { center, entries, totalHeight, rectHeight: Math.max(30, totalHeight + 6), fontSize, fontFamily, lineHeight, maxWidth, rectWidth };
            }

            // ---- DIRECTIONAL ARROWS (per-metric when showMetrics) ----
            const actionDirectionalArrowsSeries = {
                name: "ActionDirectionalArrows",
                type: "custom",
                coordinateSystem: "cartesian2d",
                silent: true,
                z: 101,
                animation: false,
                renderItem: (params, api) => {
                    const e = dottedEdges[params.dataIndex];
                    if (!e) return { type: "group", children: [] };

                    const ctx = this._measureCtx || document.createElement("canvas").getContext("2d");
                    const layout = getMetricLayout(api, e, params, ctx);
                    if (!layout) return { type: "group", children: [] };
                    const { entries, rectWidth, rectHeight } = layout;
                    const fontSize = 11;
                    const arrowWidth = 14;
                    const arrowHeight = 14;
                    const children = [];
                    entries.forEach(entry => {
                        const isSingleMetric = entries.length === 1;
                        const arrowY = isSingleMetric
                            ? layout.center[1] + rectHeight / 2 + 1 + arrowHeight / 2
                            : entry.y;
                        const arrowX = isSingleMetric
                            ? layout.center[0]
                            : layout.center[0] - rectWidth / 2 - 3 - arrowWidth / 2;
                        if (entry.direction === "no data") {
                            children.push({
                                type: "text",
                                style: {
                                    text: "--",
                                    x: arrowX,
                                    y: arrowY,
                                    textAlign: "center",
                                    textVerticalAlign: "middle",
                                    fontSize,
                                    fill: "#BFBFBF"
                                }
                            });
                            return;
                        }
                        const isNeutral = entry.direction === "neutral";
                        const isPositive = entry.direction === "positive";
                        const points = isNeutral
                            ? [[0, 0], [14, 7], [0, 14]]
                            : isPositive
                                ? [[7, 0], [14, 14], [0, 14]]
                                : [[0, 0], [14, 0], [7, 14]];

                        children.push({
                            type: "polygon",
                            shape: {
                                points: points.map(([x, y]) => [
                                    arrowX - arrowWidth / 2 + x,
                                    arrowY - arrowHeight / 2 + y
                                ])
                            },
                            style: { fill: isNeutral ? "#BFBFBF" : entry.color || (isPositive ? "#2ecc71" : "#e74c3c") }
                        });
                    });

                    return { type: "group", children };
                },
                data: dottedEdges
            };

            // ---- MARKET TYPE LABEL ----
            const actionMarketTypeSeries = {
                name: "ActionMarketType",
                type: "custom",
                coordinateSystem: "cartesian2d",
                silent: true,
                z: 102,
                animation: false,
                renderItem: (params, api) => {
                    if (!api || typeof api.coord !== "function") {
                        return { type: "group", children: [] };
                    }

                    const coord = api.coord([62, 60]);
                    const marketType = String(this.marketType || "").trim();
                    const boxWidth = Math.max(120, marketType.length * 7);
                    const boxHeight = 46;
                    return {
                        type: "group",
                        children: [
                            {
                                type: "rect",
                                shape: {
                                    x: coord[0] - boxWidth / 2,
                                    y: coord[1] - boxHeight / 2,
                                    width: boxWidth,
                                    height: boxHeight,
                                    r: 12
                                },
                                style: { fill: "#ffffff" }
                            },
                            {
                                type: "text",
                                style: {
                                    x: coord[0],
                                    y: coord[1] - 9,
                                    text: "MARKET TYPE",
                                    textAlign: "center",
                                    textVerticalAlign: "middle",
                                    fontSize: 14,
                                    fill: "#000000",
                                    fontFamily: "Franklin Gothic Medium Cond, sans-serif"
                                }
                            },
                            {
                                type: "text",
                                style: {
                                    x: coord[0],
                                    y: coord[1] + 8,
                                    text: marketType,
                                    textAlign: "center",
                                    textVerticalAlign: "middle",
                                    fontSize: 16,
                                    fill: "#5986d4",
                                    fontFamily: "Franklin Gothic Demi Cond, sans-serif"
                                }
                            }
                        ]
                    };
                },
                data: [0]
            };
            // ---- ACTION TEXT SERIES (centered on dotted lines) ----
            const actionTextSeries = {
                name: "ActionLabels",
                type: "custom",
                coordinateSystem: "cartesian2d",
                z: 100,
                //zlevel: 10,
                renderItem: (params, api) => {
                    const e = dottedEdges[params.dataIndex];
                    if (!e) return { type: "group", children: [] };

                    const act = (e.action || "").trim();
                    if (!act) return { type: "group", children: [] };

                    // same side offsets as traffic, so they move together
                    let sideOffset = 0;
                    let verticalOffset = 0;
                    if (String(e.id) === "6") {
                        sideOffset = 18;
                    } else if (String(e.id) === "8") {
                        // verticalOffset = -30; // move up a bit
                        // sideOffset = -28;
                    } else if (String(e.id) === "9") {
                        sideOffset = -18;
                        verticalOffset = 22; // move down a bit
                    } else if (String(e.id) === "12") {
                        sideOffset = -18;    // line 8 → a bit to the "right"
                    }

                    const center = getDottedMidpoint(api, e, sideOffset, verticalOffset, params);
                    if (!center) return { type: "group", children: [] };

                    if (String(e.id) === "2") {
                        center[0] -= 30;   // left
                        center[1] += 10;   // down
                    } else if (String(e.id) === "3") {
                        // center[0] += 50;   // right
                        center[1] += 20;   // down
                    } else if (String(e.id) === "7") {
                        center[0] -= 25;   // left
                        center[1] -= 30;   // up
                    } else if (String(e.id) === "8") {
                        center[0] += 45;   // move right
                        center[1] -= 30;   // move up
                    } else if (String(e.id) === "9") {
                        center[0] += 20;   // move right
                        center[1] -= 40;   // move up
                    }

                    const fontSize = 11;
                    const rectWidth = 70;   // fixed width
                    const rectHeight = 30;   // fixed height
                    const paddingX = 5;
                    const paddingY = 3;
                    const maxWidth = rectWidth - paddingX * 2;  // wrap within fixed width

                    const ctx =
                        this._measureCtx ||
                        document.createElement("canvas").getContext("2d");
                    ctx.font = `${fontSize}px sans-serif`;

                    const words = act.split(" ");
                    const lines = [];
                    let line = "";
                    for (const w of words) {
                        const test = line ? `${line} ${w}` : w;
                        if (ctx.measureText(test).width > maxWidth && line) {
                            lines.push(line);
                            line = w;
                        } else {
                            line = test;
                        }
                    }
                    if (line) lines.push(line);

                    const lineHeight = fontSize + 2;

                    return {
                        type: "group",
                        children: [
                            {
                                // fixed-size rectangle centered on `center`
                                type: "rect",
                                shape: {
                                    x: center[0] - rectWidth / 2,
                                    y: center[1] - rectHeight / 2,
                                    width: rectWidth,
                                    height: rectHeight,
                                    r: 4
                                },
                                style: {
                                    fill: "#fff",
                                    stroke: "#ddd",
                                    shadowColor: "rgba(0,0,0,0.05)",
                                    shadowBlur: 2
                                }
                            },
                            {
                                type: "text",
                                style: {
                                    x: center[0],
                                    y: center[1],                   // vertical center
                                    text: lines.join("\n"),
                                    textAlign: "center",
                                    textVerticalAlign: "middle",    // vertical center alignment
                                    lineHeight,
                                    width: maxWidth,                // wrapping width
                                    fill: "#333",
                                    fontSize: 12,
                                    fontFamily: "Franklin Gothic Medium Cond, sans-serif",
                                }
                            }
                        ]
                    };
                },
                data: dottedEdges
            };

            // ---- METRICS TEXT SERIES ----
            const metricsTextSeries = {
                name: "MetricsLabels",
                type: "custom",
                coordinateSystem: "cartesian2d",
                z: 100,
                renderItem: (params, api) => {
                    const e = dottedEdges[params.dataIndex];
                    if (!e) return { type: "group", children: [] };

                    const ctx = this._measureCtx || document.createElement("canvas").getContext("2d");
                    const layout = getMetricLayout(api, e, params, ctx);
                    if (!layout) return { type: "group", children: [] };
                    const { center, entries, rectHeight, fontSize, fontFamily, lineHeight, maxWidth, rectWidth } = layout;
                    return {
                        type: "group",
                        children: [
                            {
                                type: "rect",
                                shape: { x: center[0] - rectWidth / 2, y: center[1] - rectHeight / 2, width: rectWidth, height: rectHeight, r: 4 },
                                style: { fill: "#F9F9F9", stroke: "none" }
                            },
                            ...entries.map(entry => ({
                                type: "text",
                                style: {
                                    x: center[0], y: entry.y, text: entry.lines.join("\n"),
                                    textAlign: "center", textVerticalAlign: "middle",
                                    fontSize, fontFamily, lineHeight, width: maxWidth, fill: "#000"
                                }
                            }))
                        ]
                    };
                },
                data: dottedEdges
            };

            // ---- MOATS TEXT SERIES ----
            const moatsTextSeries = {
                name: "MoatLabels",
                type: "custom",
                coordinateSystem: "cartesian2d",
                z: 100,
                //zlevel: 10,
                renderItem: (params, api) => {
                    const e = dottedEdges[params.dataIndex];
                    if (!e) return { type: "group", children: [] };
                    //const [src, dst, , , , moatName] = e;

                    const moat = (e.moatName || "").trim();
                    if (!moat) return { type: "group", children: [] };

                    // same side offsets as traffic, so they move together
                    let sideOffset = 0;
                    let verticalOffset = 0;
                    if (String(e.id) === "6") {
                        sideOffset = 18;
                    } else if (String(e.id) === "8") {
                        // verticalOffset = 15; // move down a bit
                    } else if (String(e.id) === "9") {
                        sideOffset = -18;
                        verticalOffset = 22; // move down a bit
                    } else if (String(e.id) === "12") {
                        sideOffset = -18;    // line 8 → a bit to the "right"
                    }

                    const center = getDottedMidpoint(api, e, sideOffset, verticalOffset, params);
                    if (!center) return { type: "group", children: [] };
                    if (String(e.id) === "2") {
                        center[0] -= 30;   // left
                        center[1] += 10;   // down
                    } else if (String(e.id) === "3") {
                        // center[0] += 50;   // right
                        center[1] += 20;   // down
                    } else if (String(e.id) === "8") {
                        center[0] += 40;   // move right
                        center[1] -= 30;   // move up
                    } else if (String(e.id) === "9") {
                        center[0] += 20;   // move right
                        center[1] -= 40;   // move up
                    }
                    const fontSize = 11;
                    const rectWidth = 80;   // fixed width
                    const rectHeight = 30;   // fixed height
                    const paddingX = 5;
                    const paddingY = 3;
                    const maxWidth = rectWidth - paddingX * 2;  // wrap within fixed width

                    const ctx =
                        this._measureCtx ||
                        document.createElement("canvas").getContext("2d");
                    ctx.font = `${fontSize}px sans-serif`;

                    const words = moat.split(" ");
                    const lines = [];
                    let line = "";
                    for (const w of words) {
                        const test = line ? `${line} ${w}` : w;
                        if (ctx.measureText(test).width > maxWidth && line) {
                            lines.push(line);
                            line = w;
                        } else {
                            line = test;
                        }
                    }
                    if (line) lines.push(line);

                    const lineHeight = fontSize + 2;

                    // ========= NEW: decide text color from moat_display_options =========
                    let textColor = "#000000"; // default black
                    let bgcolor = "#bf9000"; // default brown

                    const opts = this.moat_display_options || this.moat_display_options;
                    if (opts) {
                        const pioneer = opts["pioneer-moats"] || [];
                        const core  = opts["core-moats"]  || [];

                        if (pioneer.includes(moat)) {
                            bgcolor = "#826300"; // yellow
                            textColor = "#ffffff";
                        } else if (core.includes(moat)) {
                            bgcolor = "#ffe48f"; // dark brown
                        }
                    }

                    return {
                        type: "group",
                        children: [
                            {
                                // fixed-size rectangle centered on `center`
                                type: "rect",
                                shape: {
                                    x: center[0] - rectWidth / 2,
                                    y: center[1] - rectHeight / 2,
                                    width: rectWidth,
                                    height: rectHeight,
                                    r: 4
                                },
                                style: {
                                    fill: bgcolor,
                                    stroke: "none",
                                    shadowColor: "rgba(0,0,0,0.05)",
                                    shadowBlur: 2
                                }
                            },
                            {
                                type: "text",
                                style: {
                                    x: center[0],
                                    y: center[1],                   // vertical center
                                    text: lines.join("\n"),
                                    textAlign: "center",
                                    textVerticalAlign: "middle",    // vertical center alignment
                                    fontSize: 12,
                                    lineHeight,
                                    width: maxWidth,                // wrapping width
                                    fill: textColor,
                                    fontFamily: "Franklin Gothic Demi Cond, sans-serif",
                                }
                            }
                        ]
                    };
                },
                data: dottedEdges
            };

            function wrapTextByWidth(text, maxWidth, ctx) {
                if (!text) return [];

                // Split on spaces and hyphens, but keep the delimiters
                const tokens = String(text).split(/([\s-]+)/); // capturing group keeps separators
                const lines = [];
                let line = "";

                for (const tok of tokens) {
                    const test = line + tok;
                    if (ctx.measureText(test).width > maxWidth && line.trim()) {
                        lines.push(line.trim());
                        line = tok.trimStart();
                    } else {
                        line = test;
                    }
                }
                if (line.trim()) lines.push(line.trim());

                return lines;
            }

            // ---- NEEDS TEXT SERIES ----
            const needsTextSeries = {
                name: "NeedLabels",
                type: "custom",
                coordinateSystem: "cartesian2d",
                z: 100,
                //zlevel: 10,
                renderItem: (params, api) => {
                    const e = dottedEdges[params.dataIndex];
                    if (!e) return { type: "group", children: [] };

                    // needName can be array or string
                    const rawNeeds = Array.isArray(e.needName)
                        ? e.needName
                        : (e.needName ? [e.needName] : []);

                    const needs = rawNeeds
                        .map(n => String(n || "").trim())
                        .filter(Boolean);

                    if (!needs.length) return { type: "group", children: [] };

                    // same side offsets as traffic, so they move together
                    let sideOffset = 0;
                    let verticalOffset = 0;
                    if (String(e.id) === "6") {
                        sideOffset = 18;
                    } else if (String(e.id) === "8") {
                        sideOffset = -20;
                    } else if (String(e.id) === "12") {
                        sideOffset = -18;
                    }

                    const fontSize = 11;
                    const paddingX = 5;
                    const paddingY = 3;
                    const lineHeight = fontSize + 2;
                    const maxWidth = 70;

                    const ctx =
                        this._measureCtx ||
                        document.createElement("canvas").getContext("2d");
                    ctx.font = `${fontSize}px sans-serif`;

                    const children = [];

                    // ===== CASE 1: exactly TWO needs → one above, one below dotted line =====
                    if (needs.length === 2) {
                        const verticalDelta = 14; // distance above / below line

                        needs.forEach((needText, idx) => {
                            const localVerticalOffset =
                                idx === 0
                                    ? verticalOffset - verticalDelta   // above
                                    : verticalOffset + verticalDelta;  // below

                            const center = getDottedMidpoint(api, e, sideOffset, localVerticalOffset, params);
                            if (!center) return { type: "group", children: [] };

                            const lines = wrapTextByWidth(needText, maxWidth, ctx);
                            if (!lines.length) return;

                            let maxLineWidth = 0;
                            lines.forEach(line => {
                                const w = ctx.measureText(line).width;
                                if (w > maxLineWidth) maxLineWidth = w;
                            });

                            const rectWidth = maxLineWidth + paddingX * 2;
                            const rectHeight = lines.length * lineHeight + paddingY * 2;

                            children.push(
                                {
                                    type: "rect",
                                    shape: {
                                        x: center[0] - rectWidth / 2,
                                        y: center[1] - rectHeight / 2,
                                        width: rectWidth,
                                        height: rectHeight,
                                        r: 4
                                    },
                                    style: { fill: "#F9F9F9" }
                                },
                                {
                                    type: "text",
                                    style: {
                                        x: center[0],
                                        y: center[1],
                                        text: lines.join("\n"),
                                        textAlign: "center",
                                        textVerticalAlign: "middle",
                                        fontSize: 12,
                                        lineHeight,
                                        width: rectWidth - paddingX * 2,
                                        fill: "#5986d4",
                                        fontFamily: "Franklin Gothic Medium Cond, sans-serif",
                                    }
                                }
                            );
                        });

                        return { type: "group", children };
                    }

                    // ===== CASE 2: 1 or >2 needs → single box, each need on its own block, wrapped =====
                    const allLines = [];
                    needs.forEach((needText, idx) => {
                        const wrapped = wrapTextByWidth(needText, maxWidth, ctx);
                        if (!wrapped.length) return;
                        wrapped.forEach(l => allLines.push(l));
                        // optional: add a small spacer line between different needs
                        if (idx < needs.length - 1) {
                            allLines.push(""); // comment out this line if no extra space required
                        }
                    });

                    if (!allLines.length) return { type: "group", children: [] };

                    let maxLineWidth = 0;
                    allLines.forEach(line => {
                        const w = ctx.measureText(line).width;
                        if (w > maxLineWidth) maxLineWidth = w;
                    });

                    const rectWidth = maxLineWidth + paddingX * 2;
                    const rectHeight = allLines.length * lineHeight + paddingY * 2;

                    const center = getDottedMidpoint(api, e, sideOffset, verticalOffset, params);
                    if (!center) return { type: "group", children: [] };
                    if (String(e.id) === "2") {
                        center[0] -= 30;   // left
                        center[1] += 10;   // down
                    } else if (String(e.id) === "3") {
                        center[0] += 0;   // right
                        center[1] += 20;   // up
                    } else if (String(e.id) === "7") {
                        center[0] -= 25;   // left
                        center[1] -= 30;   // up
                    } else if (String(e.id) === "8") {
                        center[0] += 27;   // move right
                        center[1] -= 45;   // move up
                    } else if (String(e.id) === "9") {
                        center[0] += 27;   // move right
                        center[1] -= 0;   // move up
                    }
                    children.push(
                        {
                            type: "rect",
                            shape: {
                                x: center[0] - rectWidth / 2,
                                y: center[1] - rectHeight / 2,
                                width: rectWidth,
                                height: rectHeight,
                                r: 4
                            },
                            style: { fill: "#F9F9F9" }
                        },
                        {
                            type: "text",
                            style: {
                                x: center[0],
                                y: center[1],
                                text: allLines.join("\n"),
                                textAlign: "center",
                                textVerticalAlign: "middle",
                                fontSize: 12,
                                lineHeight,
                                width: rectWidth - paddingX * 2,
                                fill: "#5986d4",
                                fontFamily: "Franklin Gothic Medium Cond, sans-serif",
                            }
                        }
                    );

                    return { type: "group", children };
                },
                data: dottedEdges
            };

            // graph series
            const graphSeries = {
                id: 'PlayersGraph',
                type: 'graph',
                name: 'Players',
                coordinateSystem: 'view',
                left: graphBounds.left,
                right: graphBounds.right,
                top: graphBounds.top,
                bottom: graphBounds.bottom,
                nodeScaleRatio: 0,
                roam: false,
                z: 10,                       // nodes above edges
                data: graphPlayers,
                links: [],
                label: { show: true }
            };

            // ---- Dotted rounded border along the trapezoid ----
            const dottedRoundedBorder = {
                name: 'TrapezoidDottedRounded',
                type: 'custom',
                coordinateSystem: 'cartesian2d',
                silent: true,
                z: 20,
                //zlevel: 3,
                renderItem: (params, api) => {
                    try {
                        if (!api || typeof api.coord !== 'function') {
                            return { type: 'group', children: [] };
                        }

                        // SAME geometry as basePlate (internal to the trapezoid)
                        const topY = 28, botY = 93;
                        const topLX = 18, topRX = 82;
                        const botLX = 8, botRX = 92;

                        // Polygon in order: BL → BR → TR → TL
                        const BL = api.coord([botLX, topY]);
                        const BR = api.coord([botRX, topY]);
                        const TR = api.coord([topRX, botY]);
                        const TL = api.coord([topLX, botY]);

                        const dist = (a, b) => Math.hypot(b[0] - a[0], b[1] - a[1]) || 1;
                        const moveTowards = (from, to, d) => {
                            const dx = to[0] - from[0];
                            const dy = to[1] - from[1];
                            const L = Math.hypot(dx, dy) || 1;
                            return [
                                from[0] + (dx / L) * d,
                                from[1] + (dy / L) * d
                            ];
                        };

                        // Edge lengths
                        const lenBL_BR = dist(BL, BR);
                        const lenBR_TR = dist(BR, TR);
                        const lenTR_TL = dist(TR, TL);
                        const lenTL_BL = dist(TL, BL);

                        // Hard upper bound
                        const R = 999;

                        // Absolute radii per corner (in px) - INCREASED FOR BIGGER CURVATURE
                        const bottomCornerRadiusPx = 350;  // Very big curves
                        const topCornerRadiusPx = 160;  // Larger top curves

                        // Clamp each corner radius by its two adjacent edges (<= half each edge)
                        const rBL = Math.min(
                            R,
                            bottomCornerRadiusPx,
                            lenBL_BR / 2,
                            lenTL_BL / 2
                        );
                        const rBR = Math.min(
                            R,
                            bottomCornerRadiusPx,
                            lenBL_BR / 2,
                            lenBR_TR / 2
                        );
                        const rTR = Math.min(
                            R,
                            topCornerRadiusPx,
                            lenBR_TR / 2,
                            lenTR_TL / 2
                        );
                        const rTL = Math.min(
                            R,
                            topCornerRadiusPx,
                            lenTR_TL / 2,
                            lenTL_BL / 2
                        );

                        // Trim points along edges for each corner
                        const BL_r = moveTowards(BL, BR, rBL);
                        const BL_u = moveTowards(BL, TL, rBL);

                        const BR_l = moveTowards(BR, BL, rBR);
                        const BR_u = moveTowards(BR, TR, rBR);

                        const TR_d = moveTowards(TR, BR, rTR);
                        const TR_l = moveTowards(TR, TL, rTR);

                        const TL_r = moveTowards(TL, TR, rTL);
                        const TL_d = moveTowards(TL, BL, rTL);

                        // Build path: straight segments + corner arcs (using Quadratic Bezier Curves 'Q')
                        const dPath = [
                            `M ${BL_r[0]} ${BL_r[1]}`,                          // start on bottom edge
                            `L ${BR_l[0]} ${BR_l[1]}`,                          // bottom BL→BR
                            `Q ${BR[0]} ${BR[1]} ${BR_u[0]} ${BR_u[1]}`,        // bottom-right corner
                            `L ${TR_d[0]} ${TR_d[1]}`,                          // right BR→TR
                            `Q ${TR[0]} ${TR[1]} ${TR_l[0]} ${TR_l[1]}`,        // top-right corner
                            `L ${TL_r[0]} ${TL_r[1]}`,                          // top TR→TL
                            `Q ${TL[0]} ${TL[1]} ${TL_d[0]} ${TL_d[1]}`,        // top-left corner
                            `L ${BL_u[0]} ${BL_u[1]}`,                          // left TL→BL
                            `Q ${BL[0]} ${BL[1]} ${BL_r[0]} ${BL_r[1]}`,        // bottom-left corner
                            'Z'
                        ].join(' ');

                        return {
                            type: 'path',
                            shape: { pathData: dPath },
                            style: {
                                fill: 'none',
                                stroke: '#5986d4',
                                lineWidth: 2,
                                lineDash: [1, 5],
                                lineJoin: 'round',
                                lineCap: 'round'
                            }
                        };
                    } catch (err) {
                        return { type: 'group', children: [] };
                    }
                },
                data: [0]
            };
            
            const emotionalNeeds = this.emotionalNeedsList;

            const bottomBlocksSeries = {
                name: "BottomBlocks",
                type: "custom",
                coordinateSystem: "cartesian2d",
                silent: true,
                z: 30,
                //zlevel: 5,
                animation: false,            // <--- add this
                progressive: 0,              // <--- prevent progressive rendering
                progressiveThreshold: 0,     // <--- (safety)
                renderItem: (params, api) => {
                    if (!api || typeof api.coord !== "function") return { type: "group", children: [] };
                    const bottomLabels = emotionalNeeds
                        .map(item => item.needLabel)
                        .filter(Boolean);
                    if (!bottomLabels[params.dataIndex]) return { type: "group", children: [] };

                    const n = bottomLabels.length;
                    if (n === 0) return { type: "group", children: [] };

                    const topY = 28,
                        botY = 93;
                    const topLX = 19,
                        topRX = 81;
                    const botLX = 6,
                        botRX = 94;

                    const BL = api.coord([botLX, topY]);
                    const BR = api.coord([botRX, topY]);
                    const TR = api.coord([topRX, botY]);
                    const TL = api.coord([topLX, botY]);

                    const dist = (a, b) => Math.hypot(b[0] - a[0], b[1] - a[1]) || 1;
                    const moveTowards = (from, to, d) => {
                        const dx = to[0] - from[0];
                        const dy = to[1] - from[1];
                        const L = Math.hypot(dx, dy) || 1;
                        return [from[0] + (dx / L) * d, from[1] + (dy / L) * d];
                    };

                    const R = 100;
                    const lenBL_BR = dist(BL, BR);
                    const rBL = Math.min(R, lenBL_BR * 0.45);

                    const BL_r = moveTowards(BL, BR, rBL);
                    const BR_l = moveTowards(BR, BL, rBL);

                    let t;
                    if (n === 1) {
                        t = 0.5; // middle
                    } else {
                        const spreadFactor = 0.4;
                        const startOffset = (1 - spreadFactor) / 2;
                        t = startOffset + (params.dataIndex / (n - 1)) * spreadFactor;
                    }

                    const centerX = BL_r[0] + (BR_l[0] - BL_r[0]) * t;
                    const centerY = BL_r[1] + (BR_l[1] - BL_r[1]) * t;

                    const rectW = 60,
                        rectH = 25,
                        fontSize = 9;

                    return {
                        type: "group",
                        children: [
                            {
                                type: "rect",
                                shape: {
                                    x: centerX - rectW / 2,
                                    y: centerY - rectH / 2,
                                    width: rectW,
                                    height: rectH,
                                    r: 0
                                },
                                style: {
                                    fill: "#5986d4",
                                    stroke: "#5986d4",
                                    lineWidth: 1.5
                                }
                            },
                            {
                                type: "text",
                                style: {
                                    x: centerX,
                                    y: centerY,
                                    text: bottomLabels[params.dataIndex],
                                    textAlign: "center",
                                    textVerticalAlign: "middle",
                                    fontSize: 12,
                                    fontFamily: "Franklin Gothic Medium Cond, sans-serif",
                                    fill: "#fff"
                                }
                            }
                        ]
                    };
                },
                data: (emotionalNeeds || []).map((_, i) => i)
            };

            const bottomBlocksTrafficSeries = {
                name: "BottomBlocksTraffic",
                type: "custom",
                coordinateSystem: "cartesian2d",
                silent: true,
                z: 101,
                //zlevel: 10,
                renderItem: (params, api) => {
                    const bottomTrafficSignals = emotionalNeeds
                        .map(item => item.signalColor)
                        .filter(Boolean);
                    const idx = params.dataIndex;
                    if (!bottomTrafficSignals[idx]) return { type: "group", children: [] };

                    const item = bottomTrafficSignals[idx];
                    const n = bottomTrafficSignals.length;
                    const topY = 27,
                        botY = 93;
                    const topLX = 19,
                        topRX = 81;
                    const botLX = 6,
                        botRX = 94;

                    const BL = api.coord([botLX, topY]);
                    const BR = api.coord([botRX, topY]);
                    const TR = api.coord([topRX, botY]);
                    const TL = api.coord([topLX, botY]);

                    const dist = (a, b) => Math.hypot(b[0] - a[0], b[1] - a[1]) || 1;
                    const moveTowards = (from, to, d) => {
                        const dx = to[0] - from[0];
                        const dy = to[1] - from[1];
                        const L = Math.hypot(dx, dy) || 1;
                        return [from[0] + (dx / L) * d, from[1] + (dy / L) * d];
                    };

                    const R = 100;
                    const lenBL_BR = dist(BL, BR);
                    const rBL = Math.min(R, lenBL_BR * 0.45);

                    const BL_r = moveTowards(BL, BR, rBL);
                    const BR_l = moveTowards(BR, BL, rBL);

                    const spreadFactor = 0.4;
                    const startOffset = (1 - spreadFactor) / 2;
                    const t = startOffset + (idx / (n - 1)) * spreadFactor;

                    const centerX = BL_r[0] + (BR_l[0] - BL_r[0]) * t;
                    const centerY = BL_r[1] + (BR_l[1] - BL_r[1]) * t;

                    const rectH = 25;
                    const gap = 10;

                    const housingW = 20,
                        housingH = 46;
                    const lightX = centerX;
                    const lightYTop = centerY + rectH / 2 + gap;

                    const gray = "#bdc3c7";

                    // derive traffic signal color
                    const red = item === "red" ? "#e74c3c" : gray;
                    const yellow = item === "yellow" ? "#f1c40f" : gray;
                    const green = item === "green" ? "#2ecc71" : gray;

                    return {
                        type: "group",
                        children: [
                            {
                                type: "rect",
                                shape: {
                                    x: lightX - housingW / 2,
                                    y: lightYTop,
                                    width: housingW,
                                    height: housingH,
                                    r: 4
                                },
                                style: { fill: "#2c3e50" }
                            },
                            {
                                type: "circle",
                                shape: { cx: lightX, cy: lightYTop + 8, r: 5 },
                                style: { fill: red }
                            },
                            {
                                type: "circle",
                                shape: { cx: lightX, cy: lightYTop + 22, r: 5 },
                                style: { fill: yellow }
                            },
                            {
                                type: "circle",
                                shape: { cx: lightX, cy: lightYTop + 36, r: 5 },
                                style: { fill: green }
                            }
                        ]
                    };
                },
                data: (emotionalNeeds || []).map((_, i) => i)
            };

            const bottomBlocksStakesSeries = {
                name: "BottomBlocksStakes",
                type: "custom",
                coordinateSystem: "cartesian2d",
                silent: true,
                z: 101,
                //zlevel: 10,
                renderItem: (params, api) => {
                    const bottomStakes = emotionalNeeds
                        .map(item => item.liftSeriesName)
                        .filter(Boolean);
                    const idx = params.dataIndex;
                    if (!bottomStakes[idx]) return { type: "group", children: [] };

                    const item = bottomStakes[idx];
                    const n = bottomStakes.length;
                    const topY = 27,
                        botY = 93;
                    const topLX = 19,
                        topRX = 81;
                    const botLX = 6,
                        botRX = 94;
                    const paddingX = 5;

                    const BL = api.coord([botLX, topY]);
                    const BR = api.coord([botRX, topY]);
                    const TR = api.coord([topRX, botY]);
                    const TL = api.coord([topLX, botY]);

                    const dist = (a, b) => Math.hypot(b[0] - a[0], b[1] - a[1]) || 1;
                    const moveTowards = (from, to, d) => {
                        const dx = to[0] - from[0];
                        const dy = to[1] - from[1];
                        const L = Math.hypot(dx, dy) || 1;
                        return [from[0] + (dx / L) * d, from[1] + (dy / L) * d];
                    };

                    const R = 100;
                    const lenBL_BR = dist(BL, BR);
                    const rBL = Math.min(R, lenBL_BR * 0.45);

                    const BL_r = moveTowards(BL, BR, rBL);
                    const BR_l = moveTowards(BR, BL, rBL);

                    const spreadFactor = 0.4;
                    const startOffset = (1 - spreadFactor) / 2;
                    const t = startOffset + (idx / (n - 1)) * spreadFactor;

                    const centerX = BL_r[0] + (BR_l[0] - BL_r[0]) * t;
                    const centerY = BL_r[1] + (BR_l[1] - BL_r[1]) * t;

                    const rectH = 25;
                    const gap = 10;

                    const housingW = 56,
                        housingH = 20;
                    const lightX = centerX;
                    const lightYTop = centerY + rectH / 2 + gap;

                    const gray = "#bdc3c7";

                    return {
                        type: "group",
                        children: [
                            {
                                type: "rect",
                                shape: {
                                    x: lightX - housingW / 2,
                                    y: lightYTop,
                                    width: housingW,
                                    height: housingH,
                                    r: 4
                                },
                                style: { fill: getStakeFill(item) }
                            },
                            {
                                type: "text",
                                style: {
                                    x: lightX,
                                    y: lightYTop + gap,
                                    // text: stakes.join("\n").toUpperCase(),
                                    text: item.toUpperCase(),
                                    textAlign: "center",
                                    textVerticalAlign: "middle",
                                    fontSize: 10,
                                    lineHeight: housingH,
                                    width: housingW - paddingX * 2,
                                    fill: "#ffffff",
                                    fontFamily: "Franklin Gothic Medium Cond, sans-serif",
                                }
                            }
                        ]
                    };
                },
                data: (emotionalNeeds || []).map((_, i) => i)
            };

            // --- Legends (right side of trapezium) ---
            const legendYCenter = 200;
            const legendX = 1000;

            const legendGraphics = [
                {
                    type: "group",
                    silent: true,
                    z: 1000,
                    children: [
                        {
                            type: "circle",
                            shape: { cx: legendX, cy: legendYCenter - 40, r: 27 },
                            style: { fill: "#BFBFBF", stroke: "#BFBFBF", lineWidth: 1.5 }
                        },
                        {
                            type: "text",
                            rotation: (15 * Math.PI) / 180,
                            origin: [legendX, legendYCenter - 40],
                            style: {
                                x: legendX,
                                y: legendYCenter - 40,
                                text: "Value\nPlayers",
                                fill: "#595959",
                                fontSize: 12,
                                fontFamily: "Franklin Gothic Demi Cond, sans-serif",
                                textAlign: "center",
                                textVerticalAlign: "middle"
                            }
                        }
                    ]
                },
                ...(this.showActions
                    ? [
                        {
                            type: "group",
                            silent: true,
                            z: 1000,
                            children: [
                                {
                                    type: "rect",
                                    shape: {
                                        x: legendX - 38,
                                        y: legendYCenter + 10,
                                        width: 80,
                                        height: 30,
                                        r: 4
                                    },
                                    style: {
                                        fill: "#fff",
                                        stroke: "#ddd",
                                        shadowColor: "rgba(0,0,0,0.05)",
                                        shadowBlur: 2
                                    }
                                },
                                {
                                    type: "text",
                                    style: {
                                        x: legendX,
                                        y: legendYCenter + 25,
                                        text: "Process",
                                        textAlign: "center",
                                        textVerticalAlign: "middle",
                                        fill: "#333",
                                        fontSize: 12,
                                        fontFamily: "Franklin Gothic Medium Cond, sans-serif",
                                    }
                                }
                            ]
                        }
                    ]
                    : []),
                ...(this.showMetrics
                    ? [
                        {
                            type: "group",
                            silent: true,
                            z: 1000,
                            children: [
                                {
                                    type: "text",
                                    style: {
                                        x: legendX,
                                        y: legendYCenter + 24,
                                        text: "Metrics",
                                        textAlign: "center",
                                        textVerticalAlign: "middle",
                                        fontSize: 12,
                                        fontFamily: "Franklin Gothic Medium Cond, sans-serif",
                                        fill: "#000",
                                    }
                                }
                            ]
                        }
                    ]
                    : []),
                ...(this.showMoats
                    ? [
                        {
                            type: "group",
                            silent: true,
                            z: 1000,
                            children: [
                                {
                                    type: "rect",
                                    shape: {
                                        x: legendX - 38,
                                        y: legendYCenter + 10,
                                        width: 80,
                                        height: 30,
                                        r: 4
                                    },
                                    style: {
                                        fill: "#bf9000",
                                        stroke: "none",
                                        shadowColor: "rgba(0,0,0,0.05)",
                                        shadowBlur: 2
                                    }
                                },
                                {
                                    type: "text",
                                    style: {
                                        x: legendX,
                                        y: legendYCenter + 25,
                                        text: "Moats",
                                        textAlign: "center",
                                        textVerticalAlign: "middle",
                                        fontSize: 12,
                                        fill: "#000000",
                                        fontFamily: "Franklin Gothic Demi Cond, sans-serif",
                                    }
                                }
                            ]
                        }
                    ]
                    : []),
                ...(this.showNeeds
                    ? [
                        {
                            type: "group",
                            silent: true,
                            z: 1000,
                            children: [
                                {
                                    type: "text",
                                    style: {
                                        x: legendX,
                                        y: legendYCenter + 10,
                                        text: "Functional Needs",
                                        textAlign: "center",
                                        textVerticalAlign: "middle",
                                        fontSize: 12,
                                        fontFamily: "Franklin Gothic Medium Cond, sans-serif",
                                        fill: "#5986d4"
                                    }
                                }
                            ]
                        }
                    ]
                    : []),
                ...(this.showNeeds
                    ? [
                        {
                            type: "group",
                            silent: true,
                            z: 1000,
                            children: [
                                {
                                    type: "rect",
                                    shape: {
                                        x: legendX - 38,
                                        y: legendYCenter + 30,
                                        width: 75,
                                        height: 25,
                                        r: 0
                                    },
                                    style: {
                                        fill: "#5986d4",
                                        stroke: "#5986d4",
                                        shadowColor: "rgba(0,0,0,0.05)",
                                        shadowBlur: 2
                                    }
                                },
                                {
                                    type: "text",
                                    style: {
                                        x: legendX,
                                        y: legendYCenter + 42,
                                        text: "Emotional Needs",
                                        textAlign: "center",
                                        textVerticalAlign: "middle",
                                        fontSize: 12,
                                        fill: "#fff",
                                        fontFamily: "Franklin Gothic Medium Cond, sans-serif",
                                    }
                                }
                            ]
                        }
                    ]
                    : [])
            ];

            // const edgeTrafficSeries = showNeeds ? actionTrafficSeries : actionTrafficSingleSeries;
            // const edgeStakesSeries = showNeeds ? actionStakesSeries : actionStakesSingleSeries;
            const baseToolbox = this.getDefaultToolBox(this,null,"value-player-chart","value-player-chart");
            const vm = this;
            const customToolbox = {
                // keep whatever the default toolbox has (position, show, etc.)
                ...baseToolbox,
                show: true,
                left: 120,
                top: 25,
                feature: {
                    ...baseToolbox.feature,
                    snapImage: {
                        ...baseToolbox.feature.myCustBut2,
                        onclick() {
                            vm.executeSnap();   // call the custom method
                        },
                    },
                    saveAsImage: {  // hide default
                        ...baseToolbox.feature.saveAsImage,
                        show: false
                    },
                    mySaveAsImage: {    // custom function
                        show: true,
                        title: baseToolbox.feature.saveAsImage.title,
                        icon: baseToolbox.feature.saveAsImage.icon,
                        
                        onclick: async () => {
                            const url = await vm.getCroppedChartImage();
                            const link = document.createElement("a");
                            link.href = url;
                            link.download = "value-ontology-chart";
                            link.click();
                        }
                    }
                },
            };

            return {
                animation: false,
                animationDuration: 0,
                animationDurationUpdate: 0,
                animationEasing: "linear",

                grid: { left: 20, right: 20, top: 0, bottom: 0, containLabel: false },
                xAxis: { type: "value", min: 0, max: 100, show: false },
                yAxis: { type: "value", min: 0, max: 100, show: false },
                tooltip: {
                    trigger: "item",
                    formatter: p => {
                        if (p.seriesName === "Players") {
                            const n = this.playerNodes.find(x => x.id === p.data.id);
                            return `${n.label}`;
                        }
                        return "";
                    }
                },
                toolbox: customToolbox,
                series: [
                    basePlate,
                    dottedLinesSeries,      // NEW dotted lines
                    iconSeries,
                    graphSeries,

                    ...(this.showActions ? [actionTextSeries] : []),
                    ...(this.showMetrics ? [metricsTextSeries] : []),
                    ...(this.showMoats ? [moatsTextSeries] : []),
                    ...(this.showNeeds ? [needsTextSeries, dottedRoundedBorder, bottomBlocksSeries] : []),
                    ...(this.showTraffic
                        ? [actionTrafficSeries, bottomBlocksSeries, bottomBlocksTrafficSeries]
                        : []),
                    ...(this.showStakes ? [actionStakesSeries, actionMarketTypeSeries] : []),
                    ...(this.showNeeds && this.showStakes ? [bottomBlocksStakesSeries] : []),
                    ...(this.showMetrics && this.showDirectionalArrows ? [actionDirectionalArrowsSeries] : []),
                ],
                graphic: [
                    ...legendGraphics,
                    ...(this.spotlightPeriodDisplay ? [{
                        type: "text",
                        left: 120,
                        top: 65,
                        silent: true,
                        z: 1000,
                        style: {
                            text: `Period: ${this.spotlightPeriodDisplay}`,
                            font: "11px Franklin Gothic Demi Cond",
                            fill: "#abbac3"
                        }
                    }] : [])
                ]
            };
        },

        render() {
            if (!this.chart) return;
            const option = this.buildOption();
            // Make absolutely sure no animations & no merging of old series
            option.animation = false;
            option.animationDuration = 0;
            option.animationDurationUpdate = 0;
            this.chart.setOption(option, { notMerge: true, lazyUpdate: false });
        },

        fetchValuePlayerUserSettings() {
            let savedLabelMode = UserSettingsService.getUserSetting("value-player-label-mode");
            let savedSpotlight = UserSettingsService.getUserSetting("value-player-spotlight");
            this.isRestoringUserSettings = true;
            if (savedLabelMode && savedLabelMode.trim() !== "") {
                this.labelMode = savedLabelMode == "moats" ? "actions" : savedLabelMode;
            }
            const spotlightIsAvailable = savedSpotlight === "stakes"
                ? this.isStakesAvailable
                : savedSpotlight === "traffic"
                    ? this.isTrafficSignalsAvailable
                    : savedSpotlight === "directionalArrows"
                        ? this.isDirectionalArrowsAvailable
                        : false;
            this.showSpotlights = spotlightIsAvailable ? savedSpotlight : "";
            this.$nextTick(() => {
                this.isRestoringUserSettings = false;
            });
        },
        logChangeEventForValuePlayerSpotlight: async function () {
            await UserSettingsService.saveUserSetting("value-player-spotlight", this.showSpotlights, 0, this.saveUserSettingCallback, this);
        },
        logChangeEventForValuePlayerValueProfile: async function () {
            await UserSettingsService.saveUserSetting("value-player-value-profile-client-chart-id", this.valueProfileClientChartId, 0, this.saveUserSettingCallback, this);
        },
        logChangeEventForValuePlayerLabelMode: async function () {
            await UserSettingsService.saveUserSetting("value-player-label-mode", this.labelMode, 0, this.saveUserSettingCallback, this);
        },
        saveUserSettingCallback: function (response) {
            UserSettingsService.saveAllUserSettings(response.data.data.userSettings);
        },
    },
};
</script>
